<template>
  <div>
    <div id="admin-preloader" v-if="loading2">
      <div id="admin-loader-text">Updating</div>
      <div id="admin-loader"></div>
    </div>
    <div id="admin-preloader" v-if="loading1">
      <div id="admin-loader-text">Loading</div>
      <div id="admin-loader"></div>
    </div>

    <div v-if="changed">
    <el-dialog
      title="Add Customer"
      :visible.sync="dialogFormVisible"
      width="300px"
    >
      <el-form
        :model="formdata"
        status-icon
        ref="formdata"
        label-width="120px"
        label-position="top"
        size="medium"
        style="
                <!-- border: 1px solid #e2e2e2;
                border-radius: 5px; -->
                background-color: #fff;
                margin-top: -25px
              "
      >
        <el-form-item
          label="Name"
          prop="name"
          :rules="[
            { required: true, message: 'Customer name', trigger: 'blur' },
          ]"
        >
          <el-input placeholder="Name" v-model="formdata.name"></el-input>
        </el-form-item>

        <el-form-item
          label="Telephone Without 0"
          prop="telephone"
          :rules="[
            { required: true, message: 'telephone no is required' },
            { type: 'number', message: 'telephone no must be a number' },
          ]"
        >
          <el-input
            v-model.number="formdata.telephone"
            auto-complete="off"
            placeholder="Telephone"
            @change="checkTelephone"
          ></el-input>
        </el-form-item>
        <el-form-item class="pt-2" style="margin-bottom: 0px">
          <el-button type="primary" @click="submitCustomerForm('formdata')"
            >Add</el-button
          >
          <el-button type="danger" @click="dialogFormVisible = false"
            >Cancel</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      :width="priceTableWidth"
      :show-close="false"
      :close-on-click-modal="false"
      title="Select Price"
      center
      :visible.sync="dialogTableVisible"
    >
      <h6>{{ priceData[0] ? priceData[0].name : "" }}</h6>
      <el-table
        ref="priceTable"
        :data="priceData"
        size="mini"
        highlight-current-row
        @current-change="handleCurrentChange"
        style="width: 300px"
      >
        <!-- <el-table-column type="index" width="30"> </el-table-column> -->
         <el-table-column
          property="serial"
          label="Serial/Item Code"
          width="150"
          style="margin-right: 0px"
        >
          <template slot-scope="scope">
            {{ scope.row.serial }}
          </template>
        </el-table-column>
        <el-table-column
          property="price"
          label="Price (LKR)"
          width="120"
          style="margin-right: 0px"
        >
          <template slot-scope="scope">
            {{ scope.row.price.toLocaleString() }}
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog
        width="80%"
        title="Items"
        :visible.sync="innerVisible"
        append-to-body>
        <el-row>
          <el-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6" v-for="(item, index) in allProducts" :key="index">
            <el-card :body-style="{ padding: '0px' }">
              <img :src="item.img" class="image">
              <div style="padding: 4px 14px; font-weight: 500">
                {{ item.name }}
                <el-button @click="handleProductChange(item)" style="padding-top: 4px; display: block;" type="text">Add to Invoice</el-button>

              </div>
            </el-card>
          </el-col>
        </el-row>
    </el-dialog>

    <el-row :gutter="10" style="margin-top: 8px">
      <el-col
        style="margin-top: 0px"
        justify="space-between"
        :xs="24"
        :sm="24"
        :md="24"
        :lg="16"
        :xl="16"
      >
        <el-card
          shadow="always"
          style="background-color: #05639b; overflow: initial; margin-top: 2px"
        >
          <el-row style="margin-top: 0px" justify="space-between">
            <!-- <el-col
          :xs="24"
          :sm="24"
          :md="4"
          :lg="4"
          :xl="4"
          style="margin-right: 5px"
        >
          <el-select
            @change="handleSelect"
            v-model="storeLocation"
            placeholder="Select Store"
            size="medium"
            style="
              margin-bottom: 1px;
              border: 1px solid #409eff;
              border-radius: 5px;
            "
          >
            <el-option
              v-for="item in stores"
              :key="item.value"
              :label="item.label"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-col> -->
            <el-col
              :xs="24"
              :sm="24"
              :md="5"
              :lg="5"
              :xl="5"
              style="margin-right: 5px"
            >
              <!-- <el-input
          size="medium"
          style="border: 2px solid #5d2e8d; border-radius: 5px"
          placeholder="Barcode/SKU"
          @change="handleProductChange"
          v-model="productBarcode"
        >
        </el-input> -->
              <el-autocomplete
                size="medium"
                style="
                  margin-bottom: 1px;
                  border: 1px solid #409eff;
                  border-radius: 5px;
                  width: 100%;
                "
                popper-class="my-autocomplete"
                v-model="productBarcode"
                :fetch-suggestions="querySearch"
                placeholder="Barcode/Name"
                @select="handleProductChange"
              >
                <i class="el-icon-edit el-input__icon" slot="suffix"> </i>
                <template slot-scope="{ item }">
                  <div class="link">{{ item.name }}</div>
                  <span class="value">Barcode: {{ item.barcode }}</span>
                </template>
              </el-autocomplete>
              <el-link
                v-if="shops[0].curProducts <= 100"
                style="color: #fff"
                icon="el-icon-view"
                @click="innerVisible = true"
                >View Items</el-link
              >
            </el-col>
            <el-col
              v-if="
               ( $route.name === 'createinvoice' ||
                $route.name === 'create-quotation') && displayName !== 'starterplan shop owner'
              "
              :xs="24"
              :sm="24"
              :md="5"
              :lg="5"
              :xl="5"
              style="margin-right: 5px"
            >
              <el-input
                size="medium"
                style="
                  margin-bottom: 1px;
                  border: 1px solid #409eff;
                  border-radius: 5px;
                "
                label="Customer Mobile No"
                placeholder="Customer Mobile No"
                @change="handleCustomerChange('customer')"
                v-model="customerMobile"
              >
              </el-input>
              <el-link
                style="color: #fff"
                icon="el-icon-edit"
                @click="dialogFormVisible = true"
                >Add Customer</el-link
              >
            </el-col>
            <el-col
              v-if="$route.name === 'createinvoice' && displayName !== 'starterplan shop owner'"
              :xs="24"
              :sm="24"
              :md="5"
              :lg="5"
              :xl="5"
              style="margin-right: 5px"
            >
              <el-input
                size="medium"
                style="
                  margin-bottom: 1px;
                  border: 1px solid #409eff;
                  border-radius: 5px;
                "
                label="Referral Customer Mobile No"
                placeholder="Referral Customer Mobile No"
                @change="handleCustomerChange('referral')"
                v-model="referralCustomerMobile"
              >
              </el-input>
            </el-col>
            <el-col
              v-if="$route.name === 'create-purchase-order' && displayName !== 'starterplan shop owner'"
              :xs="24"
              :sm="24"
              :md="5"
              :lg="5"
              :xl="5"
              style="margin-right: 5px"
            >
              <el-input
                size="medium"
                style="
                  margin-bottom: 1px;
                  border: 1px solid #409eff;
                  border-radius: 5px;
                "
                label="Supplier Mobile No"
                placeholder="Supplier Mobile No"
                @change="handleSupplierChange()"
                v-model="supplierMobile"
              >
              </el-input>
            </el-col>

            <el-col
              :xs="{ span: 24, offset: 0 }"
              :sm="{ span: 24, offset: 0 }"
              :md="{ span: 8, offset: 0 }"
              :lg="{ span: 8, offset: 0 }"
              :xl="{ span: 8, offset: 0 }"
            >
              <el-card class="box-card">
                <!-- <div slot="header" class="clearfix">
                  <span>Customer Details</span>
                </div> -->
                <div
                  class="clearfix text item"
                  style="margin: -10px 0px 0px; line-height: 12px"
                >
                  <span v-if="printInvoType === 'invo'">Invoice No</span>
                  <span v-if="printInvoType === 'quota'">Quotation No</span>
                  <span v-if="printInvoType === 'po'">GRN/PO No</span>
                  <span style="float: right; padding: 0px 0">{{
                    invoiceNo
                  }}</span>
                </div>
                <div
                  v-if="customerName"
                  class="clearfix text item"
                  style="margin: 0px 0px -10px; line-height: 10px"
                >
                  <span>Customer</span>
                  <span style="float: right; padding: 0px 0">{{
                    customerName
                  }}</span>
                </div>
                <div
                  v-if="supplierName"
                  class="clearfix text item"
                  style="margin: 0px 0px -10px; line-height: 16px"
                >
                  <span>Supplier</span>
                  <span style="float: right; padding: 0px 0">{{
                    supplierName
                  }}</span>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </el-card>
        <el-col
          :xs="24"
          :sm="24"
          :md="24"
          :lg="24"
          :xl="24"
          style="margin-bottom: 15px; margin-top: 15px"
        >
        <el-card
          shadow="always"
          style="background-color: #f5fbff; overflow: initial; margin-top: 2px"
        >
          <el-table
            v-if="isInvoiceRendered"
            height="70vh"
            :data="
              products.filter(
                (data) =>
                  !search ||
                  data.name.toLowerCase().includes(search.toLowerCase())
              )
            "
            style="width: 100%; border-radius: 5px"
          >
            <el-table-column label="Name" prop="name" width="210">
              <template slot-scope="scope">{{ `${scope.row.name} ${scope.row.serial? (' - ' + scope.row.serial):''}` }}</template>
            </el-table-column>
            <el-table-column label="Quantity" prop="quantity" width="150">
              <template slot-scope="scope">
                <el-input-number
                  size="small"
                  @change="updateProducts(scope.$index, scope.row)"
                  :precision="2"
                  :min="0"
                  :max="
                    maxQuantityforRoute == 'invoice' && !$route.query.invoice
                      ? scope.row.availableQnty
                      : maxQuantityforRoute == 'invoice' && $route.query.invoice
                      ? initialProducts.find(
                          (product) =>
                            product.barcode === scope.row.barcode &&
                            product.cost === scope.row.cost &&
                            product.serial === scope.row.serial &&
                            product.price === scope.row.price
                        ).quantity
                      : maxQuantityforRoute == 'PO' && !$route.query.PO
                      ? 1000000
                      : maxQuantityforRoute == 'PO' && $route.query.PO
                      ? initialProducts.find(
                          (product) =>
                            product.barcode === scope.row.barcode &&
                            product.cost === scope.row.cost &&
                            product.serial === scope.row.serial &&
                            product.price === scope.row.price
                        ).quantity
                      : 0
                  "
                  v-model="scope.row.quantity"
                ></el-input-number>
              </template>
            </el-table-column>
            <el-table-column label="Price (LKR)" prop="price" width="150">
              <template slot-scope="scope">
                <el-input-number
                  size="small"
                  @change="updateProducts(scope.$index, scope.row)"
                  :precision="2"
                  :min="0"
                  :disabled="$route.query.invoice ? true : false"
                  v-model="scope.row.price"
                ></el-input-number>
              </template>
            </el-table-column>
            <el-table-column label="Discount %" prop="discount" width="150">
              <template slot-scope="scope">
                <el-input-number
                  size="small"
                  @change="updateProducts(scope.$index, scope.row)"
                  :precision="2"
                  :min="0"
                  :max="100"
                  :disabled="$route.query.invoice ? true : false"
                  v-model="scope.row.discount"
                ></el-input-number>
              </template>
            </el-table-column>
            <el-table-column label="Sub Total (LKR)" width="100">
              <template slot-scope="scope">
                <span style="">
                  {{ scope.row.subTotal.toLocaleString() }}
                </span>
              </template>
            </el-table-column>
            <el-table-column align="right">
              <template slot="header" slot-scope="scope">
                <el-input v-model="search" size="mini" placeholder="Search" />
              </template>
              <template slot-scope="scope">
                <!-- <el-button
                size="mini"
                @click="handleEdit(scope.$index, scope.row)"
                >Edit</el-button
              > -->
                <el-button
                  v-if="!$route.query.invoice"
                  size="mini"
                  type="danger"
                  @click="handleDelete(scope.$index, scope.row)"
                  >Remove</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-card>
        </el-col>
      </el-col>
      <el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8">
        <el-card
          class="box-card"
          style="background-color: rgb(56 98 203); color: #fff"
        >
          <div class="clearfix text item">
            <span>Gross Amount</span>
            <span style="float: right; padding: 3px 0"
              >{{ grossAmount.toLocaleString() }} LKR</span
            >
          </div>
          <div class="clearfix text item">
            <span>Products Discount</span>
            <span style="float: right; padding: 3px 0"
              >{{ discount.toLocaleString() }} LKR
            </span>
          </div>
          <div class="clearfix text item">
            <span>Other Discount</span>
            <span style="float: right; padding: 3px 0">
              <el-input-number
                size="mini"
                @change="updatePaymentDetails()"
                :precision="2"
                :min="0"
                v-model="otherDiscount"
              ></el-input-number>
            </span>
          </div>

          <div class="clearfix text item" v-if="invoOptions.includes('Service Charge')">
            <span
              >Service Charge
              {{ serviceChargeMode === "Percentage" ? "%" : "" }}</span
            >
            <span style="float: right; padding: 3px 0">
              <el-input-number
                @change="updatePaymentDetails()"
                size="mini"
                :precision="2"
                :min="0"
                :max="serviceChargeMode === 'Percentage' ? 100 : grossAmount"
                v-model="sCharge"
              ></el-input-number>
            </span>
          </div>
          <div class="clearfix text item" v-if="invoOptions.includes('Delivery Charge')">
            <span
              >Delivery Charge
              </span
            >
            <span style="float: right; padding: 3px 0">
              <el-input-number

                size="mini"
                :precision="2"
                :min="0"
                v-model="dilCharge"
              ></el-input-number>
            </span>
          </div>
          <div class="clearfix text item">
            <span>Net Amount</span>
            <span style="float: right; padding: 3px 0"
              >{{ netAmount.toLocaleString() }} LKR</span
            >
          </div>

          <div class="clearfix text item" v-if="invoOptions.includes('Tax')">
            <span
              >Tax
              {{ taxMode === "Percentage" ? "%" : "" }}</span
            >
            <span style="float: right; padding: 3px 0">
              <el-input-number
                @change="updatePaymentDetails()"
                size="mini"
                :precision="2"
                :min="0"
                :max="taxMode === 'Percentage' ? 100 : netAmount"
                v-model="tax"
              ></el-input-number>
            </span>
          </div>
          <!-- <div class="clearfix">
            <span style="color: #000; margin-bottom: 5px">Payment Details</span>
          </div> -->
          <div class="clearfix text item" v-if="invoOptions.includes('Card Payment')">
            <span>Card Payment</span>
            <span style="float: right; padding: 3px 0">
              <el-input-number
                size="mini"
                @change="updateCardPayment()"
                :precision="2"
                :min="0"
                v-model="cardPayment"
              ></el-input-number>
            </span>
          </div>
          <div class="clearfix text item" v-if="invoOptions.includes('Card Payment')">
            <span>Add Card Payment 3%</span>
            <span style="float: right; padding: 3px 0">
              <el-checkbox
                @change="updateCardPayment()"
                v-model="card3Percent"
                style="
                   {
                    color: #fff;
                  }
                "
              ></el-checkbox>
            </span>
          </div>
          <div class="clearfix text item">
            <span>Cash Payment</span>
            <span style="float: right; padding: 3px 0">
              <el-input-number
                size="mini"
                @change="updatePaymentDetails()"
                :precision="2"
                :min="0"
                v-model="cashPayment"
              ></el-input-number>
            </span>
          </div>
          <div class="clearfix text item" v-if="invoOptions.includes('Cheque Payment')">
            <span>Cheque Payment</span>
            <span style="float: right; padding: 3px 0">
              <el-input-number
                size="mini"
                @change="updatePaymentDetails()"
                :precision="2"
                :min="0"
                v-model="chequePayment"
              ></el-input-number>
            </span>
          </div>
          <div class="clearfix text item" v-if="invoOptions.includes('Gift Vouchers')">
            <span>Gift Vouchers</span>
            <span style="float: right; padding: 3px 0">
              <el-input-number
                size="mini"
                @change="updatePaymentDetails()"
                :precision="2"
                :min="0"
                v-model="giftVouchers"
              ></el-input-number>
            </span>
          </div>
          <div class="clearfix text item" v-if="invoOptions.includes('Loyalty Points')">
            <span>Loyalty Points</span>
            <span style="float: right; padding: 3px 0">
              <el-input-number
                size="mini"
                @change="updatePaymentDetails()"
                :precision="2"
                :min="0"
                :max="maxLoyalityPoints"
                v-model="loyalityPoints"
              ></el-input-number>
            </span>
          </div>
          <div v-if="balance < 0" class="clearfix text item">
            <span>Credit</span>
            <span style="float: right; padding: 3px 0"
              >{{ (-1 * balance).toLocaleString() }} LKR</span
            >
          </div>
          <div class="clearfix text item">
            <span>Balance</span>
            <span style="float: right; padding: 3px 0"
              >{{balance > 0 ? balance.toLocaleString() : 0 }} LKR</span
            >
          </div>
          <div v-if="!this.$route.query.invoice && !this.$route.query.PO" class="">
            <el-button v-if="invoOptions.includes('Card Payment')" @click="() => {
              cardPaymentButtonClicked = true
              cardPayment=netAmount;
              cashPayment = 0;
              updatePaymentDetails()
              }"
               style="float: right;" type="danger" round size="medium">Card</el-button>
            <el-button @click="() => {
              cashPaymentButtonClicked = true
              cashPayment=netAmount;
              cardPayment = 0;
              updatePaymentDetails()
              }"
              class="mr-3 mb-2" style="float: right;" type="success" round size="medium">Cash</el-button>
          </div>

          <div class="clearfix text item">
            <span>Notes</span>
            <div style="padding: 3px 0">
              <el-input :rows="3" type="textarea" v-model="note"></el-input>
            </div>
          </div>
          <div class="clearfix">
            <el-button
              v-if="
                ($route.name === 'create-purchase-order' ||
                  $route.name === 'createinvoice') &&
                !($route.query.invoice || $route.query.PO)
              "
              round
              :disabled="disabled"
              @click="open3"
              style="float: right; background-color: #ff6014"
              size="medium"
              type="warning"
              >SAVE & PRINT</el-button
            >
            <el-button
              v-if="$route.query.invoice || $route.query.PO"
              round
              :disabled="disabled"
              @click="open"
              style="float: right; background-color: #ff6014"
              size="medium"
              type="warning"
              >SAVE</el-button
            >
            <el-button
              v-if="$route.name === 'create-quotation'"
              round
              :disabled="disabled"
              @click="open2"
              style="float: right; background-color: #ff6014"
              size="medium"
              type="warning"
              >SAVE & PRINT</el-button
            >
            <el-button
              v-if="printOnly"
              round
              @click="PrintElem('print')"
              style="float: right; background-color: #ff6014"
              size="medium"
              type="warning"
              class="mr-3"
              >PRINT ONLY</el-button
            >
          </div>
        </el-card>
      </el-col>
    </el-row>
    <!-- <button @click="PrintElem('print')">Test Print</button> -->
    <!-- <button @click="print">Print</button>
    <button @click="printJS" class="btn btn-primary btn-block">PrintJS</button> -->
    <!-- <vue-easy-print :tableShow="true" ref="easyPrint"> -->
    <POSPrinter
      style="display: none"
      :address="address"
      :telephone="telephone"
      :logo="logo"
      :name="storeName"
      :footer="footer"
      :products="products"
      :balance="balance"
      :cardPayment="cardPayment"
      :cashier="cashierName"
      :cashPayment="cashPayment"
      :chequePayment="chequePayment"
      :giftVouchers="giftVouchers"
      :discount="discount"
      :earnedLoyalityPoints="earnedLoyalityPoints"
      :grossAmount="grossAmount"
      :invoiceNo="invoiceNo"
      :loyalityPoints="loyalityPoints"
      :netAmount="netAmount"
      :otherDiscount="otherDiscount"
      :remaining="remaining"
      :tax="taxMode === 'Percentage' ? (netAmount * tax) / 100 : tax"
      :sCharge="serviceChargeMode === 'Percentage' ? (grossAmount * sCharge) / 100 : sCharge"
      :dilCharge="dilCharge"
      :totalLoyalityPoints="customerTotalLoyalityPoints + earnedLoyalityPoints"
      :customer="customer"
      :customerName="customerName"
      :supplierName="supplierName"
      :type="printInvoType"
      :date="new Date().toLocaleString()"
      id="print"
    />

    <!--  Write your own template for printing  -->
    <!-- <template slot-scope="func">
                <demo :getChineseNumber="func.getChineseNumber" ></demo>
            </template> -->
    <!-- </vue-easy-print> -->

    <div v-if="shops.length > 0">
      <el-dialog
        title="Warning"
        :visible.sync="showUpdatedDialog"
        width="90%"
        center
      >
        <el-collapse>
          <el-collapse-item title="Customer Data" name="1">
            <el-row style="margin-top: 0px" justify="space-between">
              <el-col :md="6">
                <vue-json-pretty
                  :path="'res'"
                  :data="jsonDataforTest.cusInit"
                />
              </el-col>
              <el-col :md="6">
                <vue-json-pretty :path="'res'" :data="customer" />
              </el-col>
              <el-col :md="6">
                <vue-json-pretty
                  :path="'res'"
                  :data="jsonDataforTest.refCusInit"
                />
              </el-col>
              <el-col :md="6">
                <vue-json-pretty :path="'res'" :data="referralCustomer" />
              </el-col>
            </el-row>
          </el-collapse-item>
          <el-collapse-item title="Report Data" name="2">
            <el-col :md="8">
              <vue-json-pretty
                :path="'res'"
                :data="jsonDataforTest.reportInit"
              />
            </el-col>
            <el-col :md="8">
              <vue-json-pretty :path="'res'" :data="reports[0]" />
            </el-col>
          </el-collapse-item>
          <el-collapse-item title="Store Data" name="3">
            <el-row style="margin-top: 0px" justify="space-between">
              <el-col :md="8">
                <vue-json-pretty :path="'res'" :data="jsonDataforTest.stores" />
              </el-col>
              <el-col :md="8">
                <vue-json-pretty :path="'res'" :data="jsonDataforTest.store" />
              </el-col>
            </el-row>
          </el-collapse-item>
          <el-collapse-item title="Supplier" name="4">
            <el-row style="margin-top: 0px" justify="space-between">
              <el-col :lg="6">
                <vue-json-pretty
                  :path="'res'"
                  :data="jsonDataforTest.supInit"
                />
              </el-col>
              <el-col :lg="6">
                <vue-json-pretty :path="'res'" :data="supplier" />
              </el-col>
            </el-row>
          </el-collapse-item>
        </el-collapse>
        <el-row style="margin-top: 0px" justify="space-between">
          <el-col :md="8">
            <vue-json-pretty :path="'res'" :data="jsonDataforTest.invo" />
          </el-col>
          <el-col :md="6">
            priceListInit
            <vue-json-pretty
              :path="'res'"
              :data="jsonDataforTest.priceListInit"
            />
          </el-col>
          <el-col :md="6">
            priceListNew
            <vue-json-pretty :path="'res'" :data="jsonDataforTest.priceList" />
          </el-col>
        </el-row>
        <span slot="footer" class="dialog-footer">
          <el-button @click="showUpdatedDialog = false">Cancel</el-button>
          <el-button type="primary" @click="pushToNewRoute()"
            >Confirm</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
  </div>
</template>

<script>
import VueJsonPretty from "vue-json-pretty";
import db from "../../config/FirebaseInit";
import firebase from "firebase/app";
import POSPrinter from "./InvoiceTemplates/POSPrinter.vue";
import { store } from "../../Store";
import sizeof from "firestore-size";

// import DesktopPrinter from "./InvoiceTemplates/DesktopPrinter.vue";
// import vueEasyPrint from "vue-easy-print";
// import printJS from "print-js";
export default {
  name: "createinvoice",
  components: {
    POSPrinter,
    VueJsonPretty,
    // DesktopPrinter,
    // vueEasyPrint,
  },
  data() {
    return {
      displayName: firebase.auth().currentUser.displayName,
      loading1: true,
      loading2: false,
      changed: false,
      isInvoiceRendered: true,
      isInvoiceCreated: false,
      search: "",
      links: [],
      customer: "",
      referralCustomer: "",
      referralCustomerMobile: "",
      referralCustomerName: "",
      productBarcode: "",
      invoiceNo: Math.floor(Math.random() * 10000000001).toString(),
      date: "",
      invoiceDate: firebase.firestore.Timestamp.now(),
      storeLocation: this.$store.state.selectedStore,
      cashier: "",
      cashierName: "",
      customerMobile: "",
      customerName: "",
      customerTotalLoyalityPoints: 0,
      maxLoyalityPoints: 0,
      grossAmount: 0,
      discount: 0,
      otherDiscount: 0,
      tax: 0,
      loyalityPoints: 0,
      giftVouchers: 0,
      earnedLoyalityPoints: 0,
      earnedReferralPoints: 0,
      netAmount: 0,
      cardPayment: 0,
      cashPayment: 0,
      chequePayment: 0,
      balance: 0,
      remaining: 0,
      stores: [],
      shops: [],
      reports: [],
      categories: "",
      analyticsReport: {},
      dialogTableVisible: false,
      disabled: false,
      priceData: [],
      currentProduct: {},
      currentRow: null,
      priceTableWidth: "350px",
      isReportExsists: true,
      initialProducts: [],
      returnedProducts: [],
      returnedProductsInitialClone: [],
      returnInvoiceData: "",
      hasReturned: false,
      address: "",
      telephone: "",
      logo: "",
      footer: "",
      A4size: false,
      POSsize: false,
      POS80size: true,
      billCssFile: "../../../../static/pos80.css",
      showPrintPopup: false,
      products: [],
      invoTotalProfit: 0,
      card3Percent: false,
      card3PercentPay: 0,
      dialogFormVisible: false,
      reportTotalRemaining: 0,
      reportTotalSales: 0,
      reportTotalProfit: 0,
      profitReport: {},
      formdata: {
        name: "",
        telephone: "",
      },
      cus: 0,
      supplierMobile: "",
      supplier: "",
      supplierName: "",
      maxQuantityforRoute: "",
      jsonDataforTest: {}, //for testing
      showUpdatedDialog: false, //for testing,
      prdNameList: this.$store.state.prdNameList,
      printInvoType: "",
      printOnly: true,
      note: "",
      routeData: {},
      offlineSave: false,
      taxMode: "Percentage",
      sCharge: 0,
      dilCharge: 0,
      serviceChargeMode: "Percentage",
      storeName: "",
      invoOptions: [],
      defaultPay: '',
      kotItems: [],
      jobItems: [],
      orderItems: [],
      allProducts: [],
      innerVisible: false,
      cashPaymentButtonClicked: false,
      cardPaymentButtonClicked: false,
      kotOrJobOrOderId: '',
      //isOriginal:true,
    };
  },
  destroyed() {
    // Remove listener when component is destroyed
    // this.$barcodeScanner.destroy();
     //this.isOriginal = true;
  },
  mounted() {
    // this not need anymore as store select is disabled
    this.$root.$on("storeChange", (store) => {
      this.$store.state.selectedStore = store;
      this.storeLocation = store;
      this.handleSelect();
    });
  },
  async created() {
    if (this.$route.name === "createinvoice") {
      this.maxQuantityforRoute = "invoice";
      this.printInvoType = "invo";
      this.routeData.name = "createinvoice";
      if (this.$route.query.invoice) {
        this.routeData.invoice = this.$route.query.invoice;
        this.routeData.return = "true";
      }
    }
    if (this.$route.name === "create-quotation") {
      this.maxQuantityforRoute = "invoice"; // same as selling
      this.printInvoType = "quota";
      this.routeData.name = "create-quotation";
      if (this.$route.query.Quo) {
        this.routeData.Quo = this.$route.query.Quo;
        this.routeData.return = "true";
      }
    }
    if (this.$route.name === "create-purchase-order") {
      this.maxQuantityforRoute = "PO";
      this.printInvoType = "po";
      this.routeData.name = "create-purchase-order";
      if (this.$route.query.PO) {
        this.routeData.PO = this.$route.query.PO;
        this.routeData.return = "true";
      }
    }

    console.log("createdd!!!!!!!!!!!!!!!!", this.routeData);
    if (screen.width <= 768) this.priceTableWidth = "74%";
    const eventBus = this.$barcodeScanner.init(this.onBarcodeScanned, {
      eventBus: true,
    });
    if (eventBus) {
      eventBus.$on("start", () => {
        this.loading = true;
      });
      eventBus.$on("finish", () => {
        this.loading = false;
      });
    }
    this.cashier = this.$store.state.systemUser.id;
    this.cashierName = this.$store.state.systemUser.name;
    // this.$store.state.secondaryDatabase
    //   .collection("testcollection")
    //   .get()
    //   .then((querySnapshot) => {
    //     querySnapshot.forEach((doc) => {
    //       const data = doc.data();
    //       if (doc.data().data) this.prdNameList = doc.data().data;
    //       const bytes = sizeof(data);
    //       console.log("size of doc", bytes);
    //     });
    //   });

    this.$store.state.secondaryDatabase
      .collection("shops")
      .where("owner", "==", firebase.auth().currentUser.uid)
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          const data = {
            id: doc.id,
            categories: doc.data().categories,
            cus: doc.data().cus,
            curProducts: doc.data().curProducts,
          };
          const bytes = sizeof(doc.data());
          console.log("size of doc", bytes);
          this.shops.push(data);
          console.log("this.shops is", this.shops, data);
          this.cus = this.shops[0].cus;

          if (data.curProducts <= 100) {
            if (this.$store.state.allProducts != undefined && this.$store.state.allProducts.length !== 0) {
              this.allProducts = this.$store.state.allProducts;

              //console.log(' from STATE this.$store.state.allProducts', this.$store.state.allProducts)
            } else if (this.$store.state.allProducts.length === 0) {
              this.$store.state.secondaryDatabase
                .collection("products")
                .where("owner", "==", firebase.auth().currentUser.uid)
                .get()
                .then((querySnapshot) => {
                  var newitems = [];
                  querySnapshot.forEach((doc) => {
                    // //console.log('this.items.length is', state.items.length)
                    const data = {
                      id: doc.id,
                      name: doc.data().name,
                      barcode: doc.data().barcode,
                      altertQunty: doc.data().altertQunty,
                      category: doc.data().cat,
                      price: doc.data().disprice,
                      subcategory: doc.data().subcat,
                      profitMargin: doc.data().profitMargin,
                      priceList: doc.data().priceList,
                      totalQnty: 0,
                      img: doc.data().img,
                    };
                    data.priceList.forEach(item => data.totalQnty += item.quantity)
                    newitems.push(data);
                    this.allProducts = newitems;
                    this.$store.state.allProducts = newitems;
                    //console.log('state.items[cat]',this.$store.state.allProducts)
                  });

                });
            }
          }
        });

        this.storeFetch(this.$store.state.selectedStore);
      })
      .catch((error) => alert(error.message));

    if (
      this.$route.query.invoice ||
      this.$route.query.PO ||
      this.$route.query.Quo
    ) {
      let collection;
      if (this.$route.name === "createinvoice") {
        collection = "invoices";
      }
      if (this.$route.name === "create-purchase-order") {
        collection = "POs";
      }
      if (this.$route.name === "create-quotation") {
        collection = "quotations";
      }
      this.invoiceNo =
        this.$route.query.invoice ||
        this.$route.query.PO ||
        this.$route.query.Quo; // only one will be there

      const docRef = this.$store.state.secondaryDatabase.collection(collection);
        let firestoreQuery = docRef;
        if(this.$store.state.noDB === true) {
          firestoreQuery = firestoreQuery.where("shopOwner", "==", firebase.auth().currentUser.uid)
        }
        firestoreQuery
        // this.$store.state.secondaryDatabase.collection(collection)
        .where("invoiceNo", "==", this.invoiceNo)
        .limit(1)
        .get()
        .then((querySnapshot) => {
          // console.log("querySnapshot");
          querySnapshot.forEach((doc) => {
            console.log("querySnapshot",doc.data().date);
            const data = {
              id: doc.id,
              data: doc.data(),
            };
            (this.returnInvoiceData = data.data),
              (this.products = doc.data().products),
              (this.initialProducts = doc.data().products),
              (this.returnedProducts = doc.data().returnedProducts),
              (this.returnedProductsInitialClone = doc.data().returnedProducts);
            (this.invoiceDate = doc.data().date),
              (this.invoiceNo = doc.data().invoiceNo),
              (this.storeLocation = doc.data().storeLocation),
              (this.cashier = doc.data().cashier),
              (this.cashierName = doc.data().cashierName || ""),
              (this.customerName = doc.data().customer),
              (this.customerMobile = doc.data().customerMobile),
              (this.referralCustomerName = doc.data().referralCustomer),
              (this.referralCustomerMobile = doc.data().referralCustomerMobile),
              (this.supplierMobile = doc.data().supplierMobile),
              (this.supplierName = doc.data().supplierName),
              (this.grossAmount = doc.data().grossAmount),
              (this.discount = doc.data().discount),
              (this.otherDiscount = doc.data().otherDiscount),
              (this.tax = doc.data().tax),
              (this.taxMode = doc.data().taxMode || "Percentage"),
              (this.sCharge = doc.data().sCharge),
              (this.dilCharge = doc.data().dilCharge || 0),
              (this.serviceChargeMode = doc.data().serviceChargeMode || "Percentage"),
              (this.netAmount = doc.data().netAmount),
              (this.cardPayment = doc.data().cardPayment),
              (this.card3Percent = doc.data().addCard3),
              (this.card3PercentPay = doc.data().card3),
              (this.cashPayment = doc.data().cashPayment),
              (this.chequePayment = doc.data().chequePayment),
              (this.balance = doc.data().balance),
              (this.remaining = doc.data().remaining),
              (this.invoTotalProfit = doc.data().profit),
              (this.loyalityPoints = doc.data().loyalityPoints);
            this.earnedLoyalityPoints = doc.data().earnedLoyalityPoints;
            this.earnedReferralPoints = doc.data().earnedReferralPoints;
            this.giftVouchers = doc.data().giftVouchers;
            this.hasReturned = doc.data().hasReturned;
            this.note = doc.data().note;

            this.storeFetch(this.storeLocation);
          });
          // this.handleSelect(this.storeLocation); // need to call even for create ops as this.$root.$on("storeChange" is not using

          if (this.supplierMobile) this.handleSupplierChange();
          if (this.customerMobile) this.handleCustomerChange("customer");
          if (this.referralCustomerMobile)
            this.handleCustomerChange("referral");
        })
        .catch((error) => alert(error.message));
    }
    if (this.$route.query.kot) {
      const docRef = this.$store.state.secondaryDatabase.collection("kot");
      let firestoreQuery = docRef;
      if(this.$store.state.noDB === true) {
        firestoreQuery = firestoreQuery.where("shopOwner", "==", firebase.auth().currentUser.uid)
      }
      firestoreQuery
        .where("kotNo", "==", this.$route.query.kot).limit(1).get().then((querySnapshot) => {
          // console.log("querySnapshot");
          querySnapshot.forEach((doc) => {
            this.kotOrJobOrOderId = doc.id
            doc.data().items.forEach(item => {this.handleProductChange(item)})
            this.kotItems = doc.data().items
          })
        })
        .catch((error) => alert(error.message));
    }
    if (this.$route.query.job) {
      const docRef = this.$store.state.secondaryDatabase.collection("job");
      let firestoreQuery = docRef;
      if(this.$store.state.noDB === true) {
        firestoreQuery = firestoreQuery.where("shopOwner", "==", firebase.auth().currentUser.uid)
      }
      firestoreQuery
        .where("jobNo", "==", this.$route.query.job).limit(1).get().then(async (querySnapshot) => {
          // console.log("querySnapshot");
          let items = []
          querySnapshot.forEach((doc) => {
            this.kotOrJobOrOderId = doc.id
            items = doc.data().items
          })
          for (const [index, item] of items.entries()) {
            setTimeout(async() => {
              await this.handleProductChange(item)
               console.log("item",item,index)
            } , 3000*index)
          }
          this.jobItems = items
        })
        .catch((error) => alert(error.message));
    }
    if (this.$route.query.order) {
      const docRef = this.$store.state.secondaryDatabase.collection("orders");
      let firestoreQuery = docRef;
      if(this.$store.state.noDB === true) {
        firestoreQuery = firestoreQuery.where("shopid", "==", firebase.auth().currentUser.uid)
      }
      firestoreQuery
        .where("orderNo", "==", this.$route.query.order).limit(1).get().then((querySnapshot) => {
          // console.log("querySnapshot");
          querySnapshot.forEach((doc) => {
            this.customerMobile = doc.data().telno;
            this.kotOrJobOrOderId = doc.id
            this.handleCustomerChange('customer')
            doc.data().products.forEach(item => {this.handleProductChange(item)})
            this.orderItems = doc.data().products
          })
        })
        .catch((error) => alert(error.message));
    }

    // this.$store.state.broadcastChannel = new BroadcastChannel('tab');
    // console.log('this.$store.broadcastChannel',this.$store.state.broadcastChannel)
    // this.$store.state.broadcastChannel.postMessage('another-tab');
    // // note that listener is added after posting the message

    // this.$store.state.broadcastChannel.addEventListener('message', (msg) => {
    //   console.log('msg',msg,this.$store.state.isOriginalTab)
    //     if (msg.data === 'another-tab' && this.$store.state.isOriginalTab) {
    //         // message received from 2nd tab
    //         // reply to all new tabs that the website is already open
    //         this.$store.state.broadcastChannel.postMessage('already-open');
    //     }
    //     if (msg.data === 'already-open') {
    //         this.$store.state.isOriginalTab = false;
    //         // message received from original tab
    //         // replace this with whatever logic you need
    //         alert('Cannot open multiple instances for invoice creation');

    //         this.$router.push(`/admin/createinvoice?t=${Math.floor(Math.random() * 100001).toString()}`)
    //     }
    // });
  },

  methods: {
    storeFetch(storeId) {
      this.stores = [];
      this.$store.state.secondaryDatabase
      .collection("stores")
      .doc(storeId)
      .get()
      .then((doc) => {
        // querySnapshot.forEach((doc) => {
        const data = {
          id: doc.id,
          value: doc.id,
          label: doc.data().name,
          name: doc.data().name,
          netPay: doc.data().netPay,
          invo: doc.data().invo,
          totalProfit: doc.data().totalProfit,
          totalRemain: doc.data().totalRemain,
          PORemain: doc.data().PORemain,
          POTotal: doc.data().POTotal,
          POs: doc.data().POs,
          loyalityPoints: doc.data().setting.loyalityPoints,
          referralPoints: doc.data().setting.referralPoints,
          footer: doc.data().setting.footer,
          logo: doc.data().logo,
          address: doc.data().address,
          telephone: doc.data().telephone,
          printPaperSize: doc.data().setting.printSize,
          printPopup: doc.data().setting.printPopup,
          printOnly: doc.data().setting.printOnly,
          taxMode: doc.data().setting.taxMode || "Percentage",
          serviceChargeMode: doc.data().setting.serviceChargeMode || "Percentage",
          invoOptions: doc.data().setting.invoOptions || [],
          dailyData: doc.data().dailyData,
          invoDigits: doc.data().setting.invoDigits,
          defaultPay: doc.data().setting.defaultPay

        };
        this.stores.push(data);
        this.jsonDataforTest.stores = JSON.parse(
          JSON.stringify(this.stores)
        );
        this.address = this.stores[0].address;
        this.telephone = this.stores[0].telephone;
        this.logo = this.stores[0].logo;
        this.storeName = this.stores[0].name;
        this.footer = this.stores[0].footer;
        this.printOnly = this.stores[0].printOnly;
        this.taxMode = this.stores[0].taxMode;
        this.serviceChargeMode = this.stores[0].serviceChargeMode;
        this.invoOptions = this.stores[0].invoOptions
        this.defaultPay = this.stores[0].defaultPay;

        if (!this.$route.query.invoice && !this.$route.query.PO && !this.$route.query.Quo)  {
          if (this.stores[0].invoDigits === 8)
            this.invoiceNo = Math.floor(Math.random() * 100000001).toString()
          if (this.stores[0].invoDigits === 6)
            this.invoiceNo = Math.floor(Math.random() * 1000001).toString()
        }
        // console.log("this.shops[0].printPaperSize", this.shops[0].printSize);
        if (
          this.stores[0].printPaperSize === "A4" ||
          this.stores[0].printPaperSize === "A5"
        ) {
          this.billCssFile = "../../../../static/posA4.css";
        }
        if (this.stores[0].printPaperSize === "POS Printer 58 mm Paper") {
          this.billCssFile = "../../../../static/pos.css";
        }
        if (this.stores[0].printPopup) this.showPrintPopup = true;
        this.handleSelect(this.storeLocation); // should call afert all of this. else else
      // current date will pass as invoiceDate to get reports. this.reports set to [] in handleSelect. so
      // reports wont be duplicated. this matter when updating previous months records in this month

        // });
        this.loading1 = false;
        this.changed = true;
      })
      .catch((error) => alert(error.message));
    },
    querySearch(queryString, cb) {
      var prds = this.prdNameList;
      var results = queryString
        ? prds.filter(this.createFilter(queryString))
        : [];
      // call callback function to return suggestion objects
      cb(results);
    },
    createFilter(queryString) {
      return (prd) => {
        return (
          prd.name.toLowerCase().includes(queryString.toLowerCase()) ||
          prd.barcode.toLowerCase().includes(queryString.toLowerCase())
        );
      };
    },

    handleSelectAutoComplete(item) {
      console.log(item);
    },
    PrintElem(elem) {
      var mywindow = window.open("", "PRINT", "fullscreen=yes");

      mywindow.document.write(
        "<html><head><title>" + document.title + "</title>"
      );

      mywindow.document.write(
        `<link rel="stylesheet" href="${this.billCssFile}" type="text/css" />`
      );
      mywindow.document.write("</head><body >");
      mywindow.document.write(document.getElementById(elem).innerHTML);
      mywindow.document.write("</body></html>");

      mywindow.document.close(); // necessary for IE >= 10
      mywindow.focus(); // necessary for IE >= 10*/

      mywindow.print();
      if (!this.showPrintPopup) {
        mywindow.close();
      }

      return true;
    },
    // async print() {
    //   await this.$htmlToPaper("print");
    // },
    // printJS() {
    //   printJS({
    //     printable: "print",
    //     type: "html",
    //     css: "https://app.staticsave.com/eslkcss/pos.css",
    //   });
    // },
    // printInvoice() {
    //   // console.log("print");
    //   this.$refs.easyPrint.print();
    // },
    open3() {
      if (!this.cashPaymentButtonClicked && !this.cardPaymentButtonClicked) {
        this.$confirm("Going to Save as a credit invoice. Continue?", "Warning", {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
          center: true,
        })
        .then(() => {
          this.createInvoice();
        })
        .catch((err) => {
          alert(err);
          this.$message({
            type: "info",
            message: "Save & Print canceled",
          });
        });
      } else {
        this.$confirm("Going to Save & Print. Continue?", "info", {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "info",
          center: true,
        })
        .then(() => {
          this.createInvoice();
        })
        .catch((err) => {
          alert(err);
          this.$message({
            type: "info",
            message: "Save & Print canceled",
          });
        });
      }
    },
    open() {
      this.$confirm("Going to Save & Print. Continue?", "info", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "info",
        center: true,
      })
        .then(() => {
          this.createInvoice();
        })
        .catch((err) => {
          alert(err);
          this.$message({
            type: "info",
            message: "Save & Print canceled",
          });
        });
    },
    open2() {
      this.$confirm("Going to Save & Print. Continue?", "info", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "info",
        center: true,
      })
        .then(() => {
          this.createQuotation();
        })
        .catch((err) => {
          alert(err);
          this.$message({
            type: "info",
            message: "Save & Print canceled",
          });
        });
    },
    createInvoice() {
      this.loading2 = true;
      if (this.storeLocation === "" || this.storeLocation === undefined) {
        return alert("Please select store location");
      }
      if (!navigator.onLine) {
        this.offlineSave = true;
        if (!this.routeData.invoice && !this.routeData.PO)
          this.PrintElem("print");
      }

      // this.storeFetch(this.storeLocation); // got issues // just to update daily & monthly & total store data in case multiple tabs were opened and
          // one tab having old store data. this wont enough if user already added some products to a tab and then invoice the
          // same products in another tab and the again come back to this tab continue invoicing. its user's mistake

      let collection;
      if (this.$route.name === "createinvoice") collection = "invoices";
      if (this.$route.name === "create-purchase-order") collection = "POs";
      if (!this.$route.query.invoice && !this.$route.query.PO)
        this.invoiceDate = firebase.firestore.Timestamp.now();
      this.disabled = true;
      const productSaving = JSON.parse(JSON.stringify(this.products));
      productSaving.forEach((prd) => delete prd.priceList);
      const dto = {
        products: productSaving,
        returnedProducts: this.returnedProducts,
        prdBarcodes: productSaving.map(prd => prd.barcode),
        date: this.invoiceDate,
        updated: firebase.firestore.Timestamp.now(),
        updatedBy: this.$store.state.systemUser.name,
        hasReturned: this.hasReturned,
        invoiceNo: this.invoiceNo,
        storeLocation: this.storeLocation,
        cashier: this.cashier || "",
        cashierName: this.cashierName,
        customer: this.customerName,
        customerMobile: this.customerMobile,
        referralCustomer: this.referralCustomerName,
        referralCustomerMobile: this.referralCustomerMobile,
        supplierMobile: this.supplierMobile,
        supplierName: this.supplierName,
        grossAmount: this.grossAmount,
        discount: this.discount,
        otherDiscount: this.otherDiscount,
        tax: this.tax,
        taxMode: this.taxMode,
        sCharge: this.sCharge,
        dilCharge: this.dilCharge,
        serviceChargeMode: this.serviceChargeMode,
        netAmount: this.netAmount,
        cardPayment: this.cardPayment,
        addCard3: this.card3Percent,
        card3: this.card3PercentPay,
        cashPayment: this.cashPayment,
        chequePayment: this.chequePayment,
        balance: this.balance,
        remaining: this.remaining,
        profit: this.invoTotalProfit,
        loyalityPoints: this.loyalityPoints,
        earnedLoyalityPoints: this.earnedLoyalityPoints,
        earnedReferralPoints: this.earnedReferralPoints,
        giftVouchers: this.giftVouchers,
        note: this.note,
        offlineSave: this.offlineSave,
        shopOwner: firebase.auth().currentUser.uid,
      };
      this.jsonDataforTest.invo = dto;
      // console.log('dto',dto)
      this.$store.state.secondaryDatabase
        .collection(collection)
        .doc(this.invoiceNo)
        .set(dto)
        .then((doc) => {
          // console.log("doc is", doc);
          let productMap = {};
          this.jsonDataforTest.priceListInit = {};
          this.jsonDataforTest.priceList = productMap;
          let isPrdNameListShouldSave = false;
          this.products.forEach((product) => {
            if (!this.routeData.invoice && !this.routeData.PO) {
              let newQuantity = 0;
              if (!productMap[product.barcode]) {
                productMap[product.barcode] = product.priceList;
                this.jsonDataforTest.priceListInit[product.barcode] =
                  JSON.parse(JSON.stringify(product.priceList));
              }
              this.jsonDataforTest.priceList = productMap;
              console.log("product", productMap[product.barcode]);
              if (this.routeData.name === "createinvoice") {

                const storePrdQnty = productMap[product.barcode].find(
                  (item) =>
                    item.store === this.storeLocation &&
                    item.serial === product.serial &&
                    item.purcPr === product.cost
                );
                console.log("storePrdQnty", storePrdQnty);
                newQuantity = product.availableQnty - product.quantity;
                storePrdQnty.quantity = newQuantity;

                if (storePrdQnty.quantity <= product.altertQunty) {
                  isPrdNameListShouldSave = true;
                  const prd = this.$store.state.prdNameList.find(
                    (p) => p.barcode == product.barcode
                  );
                  if (prd.lowStock) {
                    const newLowStock = prd.lowStock.filter(
                      (item) =>
                        item.store !== this.storeLocation &&
                        item.purcPr !== product.cost
                    );
                    console.log("prd.lowStock ", prd.lowStock, newLowStock);
                    prd.lowStock = newLowStock;
                    prd.lowStock.push({
                      store: this.storeLocation,
                      purcPr: product.cost,
                      qty: newQuantity,
                    });
                    // ***************************Have to move this block to function bcz when returning this excute before
                    // ************************** fetching the return prd from db ****************************************************
                    this.savePrdNameList(isPrdNameListShouldSave);
                  } else {
                    prd.lowStock = [];
                    prd.lowStock.push({
                      store: this.storeLocation,
                      purcPr: product.cost,
                      qty: newQuantity,
                    });
                    this.savePrdNameList(isPrdNameListShouldSave);
                  }
                }

                console.log("storePrdQnty updated", storePrdQnty);
                if (
                  !this.analyticsReport[product.category] ||
                  (this.analyticsReport[product.category] &&
                    !this.analyticsReport[product.category][
                      product.subcategory
                    ])
                ) {
                  if (!this.analyticsReport[product.category]) {
                    this.analyticsReport[product.category] = {};
                    this.profitReport[product.category] = {};
                  }
                  this.analyticsReport[product.category][
                    product.subcategory
                  ] = 0;
                  this.profitReport[product.category][product.subcategory] = 0;
                }
                this.analyticsReport[product.category][product.subcategory] +=
                  product.subTotal;
                this.profitReport[product.category][product.subcategory] +=
                  product.profit;
              }
              if (this.routeData.name === "create-purchase-order") {
                const storePrdQnty = productMap[product.barcode].find(
                  (item) =>
                    item.store === this.storeLocation &&
                    item.serial === product.serial &&
                    item.purcPr === product.price
                ); // product.price bcz when purchasing this can be a new purchased price
                if (storePrdQnty) {
                  newQuantity = product.availableQnty + product.quantity;
                  storePrdQnty.quantity = newQuantity;

                  if (storePrdQnty.quantity > product.altertQunty) {
                    const prd = this.$store.state.prdNameList.find(
                      (p) => p.barcode == product.barcode
                    );
                    if (prd.lowStock) {
                      const foundLowStockItem = prd.lowStock.find(
                        (item) =>
                          item.store === this.storeLocation &&
                          item.purcPr === product.cost
                      );
                      if (foundLowStockItem) {
                        const newLowStock = prd.lowStock.filter(
                          (item) =>
                            item.store !== this.storeLocation &&
                            item.purcPr !== product.cost
                        );
                        isPrdNameListShouldSave = true;
                        console.log("prd.lowStock ", newLowStock);
                        prd.lowStock = newLowStock;
                        this.savePrdNameList(isPrdNameListShouldSave);
                      }
                    }
                  }
                }
                if (!storePrdQnty) {
                  productMap[product.barcode].push({
                    store: this.storeLocation,
                    quantity: product.quantity,
                    sellPr: 0,
                    purcPr: product.price,
                  });
                }
                console.log(
                  "productMap[product.barcode]",
                  productMap[product.barcode],
                  storePrdQnty
                );
                const foundIndex = productMap[product.barcode].findIndex(
                  (prd) => {
                    return (
                      prd.quantity === 0 &&
                      prd.sellPr === 0 &&
                      prd.purcPr === 0 &&
                      prd.store === this.storeLocation
                    );
                  }
                );
                if (foundIndex !== -1) {
                  productMap[product.barcode].splice(foundIndex, 1);
                }

                console.log(
                  "productMap[product.barcode]",
                  productMap[product.barcode],
                  foundIndex
                );
              }
              if (this.$store.state.items[product.category]) {
                const foundItem = this.$store.state.items[
                  product.category
                ].find((item) => {
                  //// console.log('filfkkk')
                  return item.id === product.id;
                });
                foundItem.priceList = productMap[product.barcode];
                var newitems = this.$store.state.items[product.category].filter(
                  (item) => {
                    //// console.log('filfkkk')
                    return item.id !== product.id;
                  }
                );
                newitems.unshift(foundItem);
                this.$store.state.items[product.category] = newitems;
                // console.log("new itemss", newitems, foundItem);
              }
              if (this.$store.state.allProducts != undefined && this.$store.state.allProducts.length !== 0) {
                const foundItem = this.$store.state.allProducts.find((item) => item.id === product.id);
                foundItem.priceList = productMap[product.barcode];
                var newitems = this.$store.state.allProducts.filter(
                  (item) =>  item.id !== product.id);
                let totalQnty = 0;
                foundItem.priceList.forEach(item => totalQnty += item.quantity)
                foundItem.totalQnty = totalQnty;
                newitems.unshift(foundItem);
                this.$store.state.allProducts = newitems;
              }
              if (!this.offlineSave) {
                this.$store.state.secondaryDatabase
                  .collection("products")
                  .doc(product.id)
                  .update({
                    priceList: productMap[product.barcode],
                  })
                  .then((doc) => {
                    console.log("doc is", doc);
                  })
                  .catch((error) => alert(error));
              } else {
                const offlineData = JSON.parse(
                  localStorage.getItem("offlineData")
                );
                offlineData.push({
                  collection: "products",
                  id: product.id,
                  ops: "update",
                  data: { priceList: productMap[product.barcode] },
                });
                localStorage.setItem(
                  "offlineData",
                  JSON.stringify(offlineData)
                );
              }
            }

            if (
              (this.routeData.invoice || this.routeData.PO) &&
              this.routeData.return === "true"
            ) {
              const returnAlreadyOriginal =
                this.returnedProductsInitialClone.find(
                  (prd) =>
                    prd.barcode == product.barcode && prd.serial === product.serial && prd.cost == product.cost
                );
              const returnInvoiceDataFoundPrd =
                this.returnInvoiceData.products.find(
                  (prd) =>
                    prd.barcode === product.barcode && prd.serial === product.serial && prd.cost === product.cost
                );
              const jsonDataforTestPriceListInit =
                this.jsonDataforTest.priceListInit;
              let jsonDataforTestPriceList = this.jsonDataforTest.priceList;

               // ***************************Have to move this block to here from below bcz when returning this excute after (bcz of product fetch from db)
              // ************************** saving report data via updateInvoiceReport() in db ****************************************************

              if (this.routeData.name === "createinvoice") {
                console.log(
                  "this.profitReport",
                  this.profitReport,
                  this.analyticsReport,
                  JSON.parse(JSON.stringify(this.profitReport)),
                  product.category
                );
                this.analyticsReport[product.category][
                  product.subcategory
                ] +=
                  product.subTotal - returnInvoiceDataFoundPrd.subTotal;
                this.profitReport[product.category][
                  product.subcategory
                ] += product.profit - returnInvoiceDataFoundPrd.profit;
              }

              this.$store.state.secondaryDatabase
                .collection("products")
                .where("owner", "==", firebase.auth().currentUser.uid)
                .where("barcode", "==", product.barcode)
                .get()
                .then((querySnapshot) => {
                  let isProductFound;
                  querySnapshot.forEach((doc) => {
                    if (doc) isProductFound = true;
                    const data = {
                      id: doc.id,
                      priceList: doc.data().priceList,
                      availableQnty: doc
                        .data()
                        .priceList.find(
                          (item) =>
                            item.store === this.storeLocation &&
                            item.serial === product.serial &&
                            item.purcPr === product.cost
                        ).quantity,
                      // qntyList: doc.data().quantity,
                    };
                    // // console.log(
                    //   "data.availableQnty + product.noOfReturns",
                    //   data.availableQnty,
                    //   product.noOfReturns,
                    //   newQuantity
                    // );
                    let newQuantity = 0;
                    if (!productMap[product.barcode]) {
                      productMap[product.barcode] = data.priceList;
                      jsonDataforTestPriceListInit[product.barcode] =
                        JSON.parse(JSON.stringify(data.priceList));
                    }
                    jsonDataforTestPriceList = productMap;
                    console.log(
                      "jsonDataforTestPriceList",

                      jsonDataforTestPriceListInit,
                      jsonDataforTestPriceList,
                      this.jsonDataforTest.priceListInit,
                      this.jsonDataforTest.priceList
                    );
                    if (this.routeData.name === "createinvoice") {
                      const storePrdQnty = productMap[product.barcode].find(
                        (item) =>
                          item.store === this.storeLocation &&
                          item.serial === product.serial &&
                          item.purcPr === product.cost
                      );
                      newQuantity =
                        data.availableQnty +
                        (product.noOfReturns ? product.noOfReturns : 0) -
                        (returnAlreadyOriginal
                          ? returnAlreadyOriginal.quantity
                          : 0);
                      storePrdQnty.quantity = newQuantity;

                      if (storePrdQnty.quantity > product.altertQunty) {
                        const prd = this.$store.state.prdNameList.find(
                          (p) => p.barcode == product.barcode
                        );
                        if (prd.lowStock) {
                          const foundLowStockItem = prd.lowStock.find(
                            (item) =>
                              item.store === this.storeLocation &&
                              item.purcPr === product.cost
                          );
                          if (foundLowStockItem) {
                            const newLowStock = prd.lowStock.filter(
                              (item) =>
                                item.store !== this.storeLocation &&
                                item.purcPr !== product.cost
                            );
                            isPrdNameListShouldSave = true;
                            console.log("prd.lowStock ", newLowStock);
                            prd.lowStock = newLowStock;
                            // ***************************Have to move this block to function bcz when returning this excute before
                            // ************************** fetching the return prd from db ****************************************************
                            this.savePrdNameList(isPrdNameListShouldSave);
                          }
                        }
                      }


                    }
                    if (this.routeData.name === "create-purchase-order") {
                      const storePrdQnty = productMap[product.barcode].find(
                        (item) =>
                          item.store === this.storeLocation &&
                          item.serial === product.serial &&
                          item.purcPr === product.price
                      ); // product.price bcz when purchasing this can be a new purchased price
                      newQuantity =
                        data.availableQnty -
                        (product.noOfReturns ? product.noOfReturns : 0) +
                        (returnAlreadyOriginal
                          ? returnAlreadyOriginal.quantity
                          : 0);
                      storePrdQnty.quantity = newQuantity;

                      if (storePrdQnty.quantity <= product.altertQunty) {
                        isPrdNameListShouldSave = true;
                        const prd = this.$store.state.prdNameList.find(
                          (p) => p.barcode == product.barcode
                        );
                        if (prd.lowStock) {
                          const newLowStock = prd.lowStock.filter(
                            (item) =>
                              item.store !== this.storeLocation &&
                              item.purcPr !== product.cost
                          );
                          console.log(
                            "prd.lowStock ",
                            prd.lowStock,
                            newLowStock
                          );
                          prd.lowStock = newLowStock;
                          prd.lowStock.push({
                            store: this.storeLocation,
                            purcPr: product.cost,
                            qty: newQuantity,
                          });
                          this.savePrdNameList(isPrdNameListShouldSave);
                        } else {
                          prd.lowStock = [];
                          prd.lowStock.push({
                            store: this.storeLocation,
                            purcPr: product.cost,
                            qty: newQuantity,
                          });
                          this.savePrdNameList(isPrdNameListShouldSave);
                        }
                      }
                    }
                    if (this.$store.state.items[product.category]) {
                      const foundItem = this.$store.state.items[
                        product.category
                      ].find((item) => {
                        //// console.log('filfkkk')
                        return item.id === product.id;
                      });
                      foundItem.priceList = productMap[product.barcode];
                      var newitems = this.$store.state.items[
                        product.category
                      ].filter((item) => {
                        //// console.log('filfkkk')
                        return item.id !== product.id;
                      });
                      newitems.push(foundItem);
                      this.$store.state.items[product.category] = newitems;
                      // console.log("new itemss", newitems, foundItem);
                    }
                    this.$store.state.secondaryDatabase
                      .collection("products")
                      .doc(product.id)
                      .update({
                        priceList: productMap[product.barcode],
                      })
                      .then((doc) => {
                        // console.log("doc is", doc);
                      })
                      .catch((error) => alert(error));
                  });
                })
                .catch((error) => console.log(error));
            }
          });

          console.log("isPrdNameListShouldSave", isPrdNameListShouldSave);

          if (this.$route.query.kot || this.$route.query.order || this.$route.query.job) {
             let collection = ''
            if (this.$route.query.kot) collection = 'kot'
            if (this.$route.query.job) collection = 'job'
            if (this.$route.query.order) collection = 'orders' //  online orders
            this.$store.state.secondaryDatabase
            .collection(collection)
            .doc(this.kotOrJobOrOderId)
            .update({
              invoice: this.invoiceNo,
            })
            .then((doc) => {
              // console.log("doc is", doc);
            })
            .catch((error) => alert(error));

          }

          if (this.routeData.name === "createinvoice") {
            if (!this.routeData.invoice && !this.routeData.PO) {
               const cashFlowsales =
                  this.balance < 0
                    ? this.cashPayment
                    : this.cashPayment - this.balance;
                this.updateCashFlow(cashFlowsales);
            }
            this.shopAndStoreUpdate("invoice");
            this.updateCustomerAndReferral();
            this.updateInvoiceReport();
            this.updateDailyData(this.invoiceDate.toDate());
          }
          if (this.routeData.name === "create-purchase-order") {
            this.shopAndStoreUpdate("PO");
            this.updateSupplier();
            this.updatePOReport();
          }

          // this.modalShow = true
          this.isInvoiceCreated = true;
          if (!this.routeData.invoice && !this.routeData.PO) {
            try {
              this.PrintElem("print");
            } catch (error) {
              this.pushToNewRoute() // in case browser block print popup
            }

          }

          this.pushToNewRoute()
          // this.showUpdatedDialog = true;

          // this.resetData();
          // if (
          //   this.$route.query.invoice &&
          //   this.$route.query.return === "true"
          // ) {
          //   this.$router.push("/admin/createinvoice");
          // }
        })
        .catch((error) => console.log(error));
    },

    pushToNewRoute() {
      this.loading2 = false;
      if (this.routeData.name === "createinvoice") {
        this.$notify({
          title: "Invoice Saved",
          message: "Invoice successfully saved",
          // duration: 0,
          type: "success",
        });
        this.$router.push(`/admin/createinvoice?n=${this.invoiceNo}`);
      }
      if (this.routeData.name === "create-purchase-order") {
        this.$notify({
          title: "GRN Saved",
          message: "GRN successfully saved",
          // duration: 0,
          type: "success",
        });
        this.$router.push(`/admin/create-purchase-order?n=${this.invoiceNo}`);
      }
    },

    // ***************************Have to move this block to function bcz when returning this excute before
    // ************************** fetching the return prd from db ****************************************************
    savePrdNameList(isPrdNameListShouldSave) {
      if (isPrdNameListShouldSave) {
        console.log("isPrdNameListShouldSave", isPrdNameListShouldSave);
        // not considering about offline as that method cannot use effectively
        let prds = 'prds';
          if(this.$store.state.noDB === true) {
            prds = `prds${firebase.auth().currentUser.uid}`
          }
        this.$store.state.secondaryDatabase
          .collection("prdlist")
          .doc(prds)
          .set({ data: this.$store.state.prdNameList })
          .then((doc) => {})
          .catch((error) => {
            alert(error);
          });
      }
    },

    updateDailyData(date) {
      if (date.toLocaleDateString() !== new Date().toLocaleDateString()) return;
      let sales = this.netAmount;
      let due = this.remaining;
      let profit = this.invoTotalProfit;
      if (this.routeData.invoice) {
        sales = this.netAmount - this.returnInvoiceData.netAmount;
        due = this.remaining - this.returnInvoiceData.remaining;
        profit = this.invoTotalProfit - this.returnInvoiceData.profit;
      }

      // const itemKey = `dailyData-${this.storeLocation}`;
      let dailyData = this.stores.find(
        (store) => store.id == this.storeLocation
      ).dailyData;
      if (dailyData && dailyData.date == new Date().toLocaleDateString()) {
        dailyData.sales += sales;
        dailyData.profit += profit;
        dailyData.due += due;
        // localStorage.setItem(itemKey, JSON.stringify(dailyData));
        console.log("dailyData", dailyData);
      } else {
        dailyData = {
          date: new Date().toLocaleDateString(),
          sales: sales,
          expenses: 0,
          profit: profit,
          due: due,
        };
        // localStorage.setItem(itemKey, JSON.stringify(dailyData));
      }
      if (!this.offlineSave) {
        this.$store.state.secondaryDatabase
          .collection("stores")
          .doc(this.storeLocation)
          .update({
            dailyData: dailyData,
          })
          .then((doc) => {})
          .catch((error) => alert(error));
      } else {
        const offlineData = JSON.parse(localStorage.getItem("offlineData"));
        offlineData.push({
          collection: "stores",
          id: this.storeLocation,
          ops: "update",
          data: { dailyData: dailyData },
        });
        localStorage.setItem("offlineData", JSON.stringify(offlineData));
      }
    },

    updateCashFlow(sales) {
      console.log("updateCashFlow")
      this.$store.state.secondaryDatabase
        .collection("cashflow")
        .where("isCurrent", "==", true)
        .where("store", "==", this.storeLocation)
        .get()
        .then((querySnapshot) => {
          const data = {};
          let isCashFlowExsists = false;
          querySnapshot.forEach((doc) => {
            isCashFlowExsists = true;
            data.id = doc.id;
            data.sales = doc.data().sales;
          });
          console.log("updateCashFlow",isCashFlowExsists,data)
          if (!isCashFlowExsists) {
            this.$store.state.secondaryDatabase
              .collection("cashflow")
              .add({
                // notes: this.notesData, // will asign when updating since undefined here
                open: 0,
                store: this.storeLocation,
                start: firebase.firestore.Timestamp.now(),
                close: 0,
                sales: sales,
                add: 0,
                deduct: 0,
                inRegi: 0,
                diff: 0,
                desc: "",
                cashData: [],
                isCurrent: true,
                updated: firebase.firestore.Timestamp.now(),
                createdBy: this.$store.state.systemUser.name,
              })
              .then((doc) => {})
              .catch((error) => alert(error));
            // console.log("this.analyticsReport is", this.analyticsReport);
          } else {
            this.$store.state.secondaryDatabase
              .collection("cashflow")
              .doc(data.id)
              .update({
                sales: data.sales + sales,
                updated: firebase.firestore.Timestamp.now(),
                updatedBy: this.$store.state.systemUser.name,
              })
              .then((docRef) => {})
              .catch((error) => alert(error));
          }
        })
        .catch((error) => alert(error));
    },

    shopAndStoreUpdate(type) {
      let netPay = "netPay";
      let totalRemain = "totalRemain";
      let invo = "invo";
      let totalProfit = "totalProfit";
      if (type === "PO") {
        netPay = "POTotal";
        totalRemain = "PORemain";
        invo = "POs";
      }
      // if (!this.shops[0][netPay]) this.shops[0][netPay] = 0;
      // if (!this.shops[0][totalRemain]) this.shops[0][totalRemain] = 0;
      // if (!this.shops[0][invo]) this.shops[0][invo] = 0;
      const storeSlct = this.stores.find(
        (store) => store.id == this.storeLocation
      );

      if (!this.routeData.invoice && !this.routeData.PO) {
        // --cannot update shop data without transaction due to concurrency -- //

        // this.shops[0][netPay] += this.netAmount;
        // this.shops[0][totalRemain] += this.remaining;
        // this.shops[0][invo] += 1;

        storeSlct[netPay] += this.netAmount;
        storeSlct[totalRemain] += this.remaining;
        storeSlct[totalProfit] += this.invoTotalProfit;
        storeSlct[invo] += 1;

        // this.reportTotalSales, this.reportTotalProfit, this.reportTotalRemaining are used as
        // properties in both invoice and PO reports updates. no issue as they are updated in separetly and accordingly
        // in 2 reports update methods
        this.reportTotalSales += this.netAmount;
        this.reportTotalProfit += this.invoTotalProfit;
        this.reportTotalRemaining += this.remaining;
      }
      if (
        (this.routeData.invoice || this.routeData.PO) &&
        this.routeData.return === "true"
      ) {
        // this.shops[0][netPay] +=
        //   this.netAmount - this.returnInvoiceData.netAmount;
        // this.shops[0][totalRemain] +=
        //   this.remaining - this.returnInvoiceData.remaining;
        // this.shops[0][invo] = this.shops[0][invo];

        storeSlct[netPay] += this.netAmount - this.returnInvoiceData.netAmount;
        storeSlct[totalRemain] +=
          this.remaining - this.returnInvoiceData.remaining;
        storeSlct[totalProfit] +=
          this.invoTotalProfit - this.returnInvoiceData.profit;
        storeSlct[invo] = storeSlct[invo];

        this.reportTotalSales +=
          this.netAmount - this.returnInvoiceData.netAmount;
        this.reportTotalProfit +=
          this.invoTotalProfit - this.returnInvoiceData.profit;
        this.reportTotalRemaining +=
          this.remaining - this.returnInvoiceData.remaining;
      }
      // this.$store.state.secondaryDatabase
      //   .collection("shops")
      //   .doc(this.shops[0].id)
      //   .update({
      //     netPay: this.shops[0][netPay],
      //     totalRemain: this.shops[0][totalRemain],
      //     invo: this.shops[0][invo],
      //   })
      //   .then((doc) => {
      //     // console.log("doc is", doc);
      //   })
      //   .catch((error) => alert(error));

      const updateObj = {
        [netPay]: storeSlct[netPay],
        [totalRemain]: storeSlct[totalRemain],
        [invo]: storeSlct[invo],
        [totalProfit]: storeSlct[totalProfit],
      };
      if (type === "PO") delete updateObj[totalProfit];
      this.jsonDataforTest.store = { [this.storeLocation]: updateObj };
      if (!this.offlineSave) {
        this.$store.state.secondaryDatabase
          .collection("stores")
          .doc(this.storeLocation)
          .update(updateObj)
          .then((doc) => {
            // console.log("doc is", doc);
          })
          .catch((error) => alert(error));
      } else {
        const offlineData = JSON.parse(localStorage.getItem("offlineData"));
        offlineData.push({
          collection: "stores",
          id: this.storeLocation,
          ops: "update",
          data: updateObj,
        });
        localStorage.setItem("offlineData", JSON.stringify(offlineData));
      }
    },

    updateInvoiceReport() {
      if (!this.isReportExsists) {
        this.$store.state.secondaryDatabase
          .collection("reports")
          .add({
            date: firebase.firestore.Timestamp.now(),
            storeLocation: this.storeLocation,
            reportData: this.analyticsReport,
            profitData: this.profitReport,
            totalSales: this.reportTotalSales,
            totalProfit: this.reportTotalProfit,
            totalRemaining: this.reportTotalRemaining,
            totalPurcCost: 0,
            totalPurcDue: 0,
            totalExp: 0,
          })
          .then((doc) => {
            // console.log("doc is", doc);
            // geting the updated report data and update properties accordingly as paged wont be reload
            // when invoice and PO creation. this part is not needed if page reload after creation like in returns saving
            if (!this.reports[0]) {
              this.$store.state.secondaryDatabase
                .collection("reports")
                .doc(doc.id)
                .get()
                .then((doc) => {
                  const data = {
                    id: doc.id,
                    categories: doc.data().reportData,
                    profitData: doc.data().profitData,
                    totalPurcCost: doc.data().totalPurcCost,
                    totalPurcDue: doc.data().totalPurcDue,
                    totalSales: doc.data().totalSales,
                    totalProfit: doc.data().totalProfit,
                    totalRemaining: doc.data().totalRemaining,
                  };
                  this.reports.push(data);
                  this.analyticsReport = this.reports[0].categories; // report's reportData property is assigned as categories
                  // in the data obj that is pushed to the this.reports array
                  this.profitReport = this.reports[0].profitData;
                  this.reportTotalSales = this.reports[0].totalSales;
                  this.reportTotalProfit = this.reports[0].totalProfit;
                  this.reportTotalRemaining = this.reports[0].totalRemaining;
                  this.isReportExsists = true;
                })
                .catch((error) => alert(error));
            }
          })
          .catch((error) => alert(error));
      }
      if (this.isReportExsists) {
        const updateObj = {
          reportData: this.analyticsReport,
          profitData: this.profitReport,
          totalSales: this.reportTotalSales,
          totalProfit: this.reportTotalProfit,
          totalRemaining: this.reportTotalRemaining,
        };
        if (!this.offlineSave) {
          this.$store.state.secondaryDatabase
            .collection("reports")
            .doc(this.reports[0].id)
            .update(updateObj)
            .then((doc) => {
              // console.log("doc is", doc);
            })
            .catch((error) => alert(error));
        } else {
          const offlineData = JSON.parse(localStorage.getItem("offlineData"));
          offlineData.push({
            collection: "reports",
            id: this.reports[0].id,
            ops: "update",
            data: updateObj,
          });
          localStorage.setItem("offlineData", JSON.stringify(offlineData));
        }
      }
    },

    updatePOReport() {
      if (!this.isReportExsists) {
        this.$store.state.secondaryDatabase
          .collection("reports")
          .add({
            date: firebase.firestore.Timestamp.now(),
            storeLocation: this.storeLocation,
            reportData: this.analyticsReport,
            profitData: this.profitReport,
            totalPurcCost: this.reportTotalSales,
            totalPurcDue: this.reportTotalRemaining,
            totalSales: 0,
            totalProfit: 0,
            totalRemaining: 0,
            totalExp: 0,
          })
          .then((doc) => {
            // console.log("doc is", doc);
            // geting the updated report data and update properties accordingly as paged wont be reload
            // when invoice and PO creation. this part is not needed if page reload after creation like in returns saving
            if (!this.reports[0]) {
              this.$store.state.secondaryDatabase
                .collection("reports")
                .doc(doc.id)
                .get()
                .then((doc) => {
                  const data = {
                    id: doc.id,
                    categories: doc.data().reportData,
                    profitData: doc.data().profitData,
                    totalPurcCost: doc.data().totalPurcCost,
                    totalPurcDue: doc.data().totalPurcDue,
                    totalSales: doc.data().totalSales,
                    totalProfit: doc.data().totalProfit,
                    totalRemaining: doc.data().totalRemaining,
                  };
                  this.reports.push(data);
                  this.analyticsReport = this.reports[0].categories; // report's reportData property is assigned as categories
                  // in the data obj that is pushed to the this.reports array
                  this.profitReport = this.reports[0].profitData;
                  this.reportTotalSales = this.reports[0].totalPurcCost;
                  this.reportTotalProfit = 0; // this wont be updated in report as this is PO report update
                  this.reportTotalRemaining = this.reports[0].totalPurcDue;
                  this.isReportExsists = true;
                })
                .catch((error) => alert(error));
            }
          })
          .catch((error) => alert(error));
      }
      if (this.isReportExsists) {
        this.$store.state.secondaryDatabase
          .collection("reports")
          .doc(this.reports[0].id)
          .update({
            reportData: this.analyticsReport,
            profitData: this.profitReport,
            totalPurcCost: this.reportTotalSales,
            totalPurcDue: this.reportTotalRemaining,
          })
          .then((doc) => {
            // console.log("doc is", doc);
          })
          .catch((error) => alert(error));
      }
    },

    updateCustomerAndReferral() {
      if (this.customer) {
        if (!this.routeData.invoice) {
          this.customer.totalPayment += this.netAmount - this.remaining;
          this.customer.totalRemaining += this.remaining;
          this.customer.totalLoyalityPoints += this.earnedLoyalityPoints;
        }
        if (
          (this.routeData.invoice || this.routeData.PO) &&
          this.routeData.return === "true"
        ) {
          this.customer.totalPayment +=
            this.netAmount -
            this.remaining -
            (this.returnInvoiceData.netAmount -
              this.returnInvoiceData.remaining);
          this.customer.totalRemaining +=
            this.remaining - this.returnInvoiceData.remaining;
          this.customer.totalLoyalityPoints +=
            this.earnedLoyalityPoints -
            this.returnInvoiceData.earnedLoyalityPoints;
        }
        if (!this.offlineSave) {
          this.$store.state.secondaryDatabase
            .collection("customers")
            .doc(this.customer.id)
            .update({
              totalPayment: this.customer.totalPayment,
              totalRemaining: this.customer.totalRemaining,
              totalLoyalityPoints: this.customer.totalLoyalityPoints,
            })
            .then((doc) => {
              if (this.$store.state.viewedCustPage) {
                const foundCus = this.$store.state.customers.find(
                  (cus) => cus.id === this.customer.id
                );
                if (foundCus) {
                  foundCus.totalLoyalityPoints =
                    this.customer.totalLoyalityPoints;
                  foundCus.totalPayment = this.customer.totalPayment;
                  foundCus.totalRemaining = this.customer.totalRemaining;
                } else this.$store.state.customers.push(this.customer);
              }
            })
            .catch((error) => alert(error));
        } else {
          const offlineData = JSON.parse(localStorage.getItem("offlineData"));
          offlineData.push({
            collection: "customers",
            id: this.customer.id,
            ops: "update",
            data: {
              totalPayment: this.customer.totalPayment,
              totalRemaining: this.customer.totalRemaining,
              totalLoyalityPoints: this.customer.totalLoyalityPoints,
            },
          });
          localStorage.setItem("offlineData", JSON.stringify(offlineData));
        }
      }
      if (this.referralCustomer) {
        if (!this.routeData.invoice) {
          this.referralCustomer.totalLoyalityPoints +=
            this.earnedReferralPoints;
        }
        if (
          (this.routeData.invoice || this.routeData.PO) &&
          this.routeData.return === "true"
        ) {
          this.referralCustomer.totalLoyalityPoints +=
            this.earnedReferralPoints -
            this.returnInvoiceData.earnedReferralPoints;
        }
        if (!this.offlineSave) {
          this.$store.state.secondaryDatabase
            .collection("customers")
            .doc(this.referralCustomer.id)
            .update({
              totalLoyalityPoints: this.referralCustomer.totalLoyalityPoints,
            })
            .then((doc) => {
              if (this.$store.state.viewedCustPage) {
                const foundCus = this.$store.state.customers.find(
                  (cus) => cus.id === this.referralCustomer.id
                );
                if (foundCus) {
                  foundCus.totalLoyalityPoints =
                    this.referralCustomer.totalLoyalityPoints;
                } else this.$store.state.customers.push(this.referralCustomer);
              }
            })
            .catch((error) => alert(error));
        } else {
          const offlineData = JSON.parse(localStorage.getItem("offlineData"));
          offlineData.push({
            collection: "customers",
            id: this.referralCustomer.id,
            ops: "update",
            data: {
              totalLoyalityPoints: this.referralCustomer.totalLoyalityPoints,
            },
          });
          localStorage.setItem("offlineData", JSON.stringify(offlineData));
        }
      }
    },

    updateSupplier() {
      // console.log('ttttttttttttttttttttttttttt5',this.routeData,this.supplier)
      if (this.supplier) {
        if (!this.routeData.PO) {
          this.supplier.totalPayment += this.netAmount - this.remaining;
          this.supplier.totalRemaining += this.remaining;
          // this.customer.totalLoyalityPoints += this.earnedLoyalityPoints;
        }

        if (this.routeData.PO && this.routeData.return === "true") {
          console.log('ttttttttttttttttttttttttttt5')
          this.supplier.totalPayment +=
            this.netAmount -
            this.remaining -
            (this.returnInvoiceData.netAmount -
              this.returnInvoiceData.remaining);
          this.supplier.totalRemaining +=
            this.remaining - this.returnInvoiceData.remaining;
          // this.customer.totalLoyalityPoints +=
          //   this.earnedLoyalityPoints -
          //   this.returnInvoiceData.earnedLoyalityPoints;
        }
        this.$store.state.secondaryDatabase
          .collection("suppliers")
          .doc(this.supplier.id)
          .update({
            totalPayment: this.supplier.totalPayment,
            totalRemaining: this.supplier.totalRemaining,
            // totalLoyalityPoints: this.customer.totalLoyalityPoints,
          })
          .then((doc) => {
            if (this.$store.state.viewedSupplierPage) {
              const foundSup = this.$store.state.suppliers.find(
                (sup) => sup.id === this.supplier.id
              );
              foundSup.totalPayment = this.supplier.totalPayment;
              foundSup.totalRemaining = this.supplier.totalRemaining;
            }
          })
          .catch((error) => alert(error));
      }
    },

    checkTelephone(form, method) {
      if (form.telephone) {
        const docRef = this.$store.state.secondaryDatabase.collection("customers");
        let firestoreQuery = docRef;
        if(this.$store.state.noDB === true) {
          firestoreQuery = firestoreQuery.where("shopOwner", "==", firebase.auth().currentUser.uid)
        }
        firestoreQuery
          .where("telephone", "==", form.telephone)
          .limit(1)
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              const telephone = form.telephone;
              form.telephone = "";
              return this.$notify.error({
                title: "Error",
                message: "Telephone no " + telephone + " is already used",
                type: "error",
              });
            });
          })
          .catch((error) => alert(error.message));
      }
    },
    submitCustomerForm(fdata) {
      this.$refs[fdata].validate((valid) => {
        if (valid) {
          this.dialogFormVisible2 = false;
          const dto = {
            name: this.formdata.name,
            email: "",
            city: "",
            regdate: firebase.firestore.Timestamp.now(),
            telephone: this.formdata.telephone,
            totalPayment: 0,
            totalRemaining: 0,
            totalLoyalityPoints: 0,
            shopOwner: firebase.auth().currentUser.uid,
          };
          this.$store.state.secondaryDatabase
            .collection("customers")
            .add(dto)
            .then((docRef) => {
              dto.id = docRef.id;
              this.customerMobile = this.formdata.telephone;
              this.customer = dto;
              this.customerName = this.formdata.name;
              this.customerTotalLoyalityPoints = 0;
              this.maxLoyalityPoints = 0;
              if (this.$store.state.viewedCustPage) {
                dto.id = docRef.id;
                dto.regdate = firebase.firestore.Timestamp.now()
                  .toDate()
                  .toLocaleString();
                this.$store.state.customers.push({ dto });
              }

              this.cus = this.cus + 1;
              this.$store.state.secondaryDatabase
                .collection("shops")
                .doc(firebase.auth().currentUser.uid)
                .update({
                  cus: this.cus,
                })
                .then(() => {
                  //console.log('secondaryDB shop id')
                })
                .catch((error) => alert(error));
              this.formdata.name = "";
              this.formdata.telephone = "";
              this.dialogFormVisible = false;
              this.$notify({
                title: "Success",
                message: "Customer added",
                type: "success",
              });
            })
            .catch((error) => alert(error));
        } else {
          return this.$notify.error({
            title: "Error",
            message: "Please Enter the Correct Details",
            type: "error",
          });
        }
      });
    },

    createQuotation() {
      if (this.storeLocation === "" || this.storeLocation === undefined) {
        return alert("Please select store location");
      }
      if (!this.routeData.Quo)
        this.invoiceDate = firebase.firestore.Timestamp.now();
      this.disabled = true;
      const productSaving = JSON.parse(JSON.stringify(this.products));
      productSaving.forEach((prd) => delete prd.priceList);
      this.$store.state.secondaryDatabase
        .collection("quotations")
        .doc(this.invoiceNo)
        .set({
          products: productSaving,
          returnedProducts: this.returnedProducts,
          date: this.invoiceDate,
          updated: firebase.firestore.Timestamp.now(),
          updatedBy: this.$store.state.systemUser.name,
          hasReturned: this.hasReturned,
          invoiceNo: this.invoiceNo,
          storeLocation: this.storeLocation,
          cashier: this.cashier || "",
          cashierName: this.cashierName,
          customer: this.customerName,
          customerMobile: this.customerMobile,
          referralCustomer: this.referralCustomerName,
          referralCustomerMobile: this.referralCustomerMobile,
          supplierMobile: this.supplierMobile,
          supplierName: this.supplierName,
          grossAmount: this.grossAmount,
          discount: this.discount,
          otherDiscount: this.otherDiscount,
          tax: this.tax,
          taxMode: this.taxMode,
          sCharge: this.sCharge,
          dilCharge: this.dilCharge,
          serviceChargeMode: this.serviceChargeMode,
          netAmount: this.netAmount,
          cardPayment: this.cardPayment,
          addCard3: this.card3Percent,
          card3: this.card3PercentPay,
          cashPayment: this.cashPayment,
          chequePayment: this.chequePayment,
          balance: this.balance,
          remaining: this.remaining,
          profit: this.invoTotalProfit,
          loyalityPoints: this.loyalityPoints,
          earnedLoyalityPoints: this.earnedLoyalityPoints,
          earnedReferralPoints: this.earnedReferralPoints,
          giftVouchers: this.giftVouchers,
          note: this.note,
          shopOwner: firebase.auth().currentUser.uid,
        })
        .then((doc) => {
          // console.log("doc is", doc);

          // this.modalShow = true
          this.isInvoiceCreated = true;
          this.$notify({
            title: "Quotation Saved",
            message: "Quotation successfully saved",
            // duration: 0,
            type: "success",
          });
          if (!this.routeData.invoice) {
            this.PrintElem("print");
          }
          // this.resetData();
          this.$router.push(`/admin/create-quotation?n=${this.invoiceNo}`);
        })
        .catch((error) => alert(error));
    },

    updateCardPayment() {
      if (this.card3Percent) {
        this.cardPayment -= this.card3PercentPay;
        this.card3PercentPay = (this.cardPayment * 3) / 100;
        this.cardPayment += this.card3PercentPay;
        this.updatePaymentDetails();
      }
      if (!this.card3Percent) {
        this.cardPayment -= this.card3PercentPay;
        this.card3PercentPay = 0;
        this.updatePaymentDetails();
      }
    },
    updatePaymentDetails() {
      console.log("card3", this.card3Percent);
      this.grossAmount = 0;
      this.discount = 0;
      this.netAmount = 0;

      this.balance = +(
        this.cardPayment +
        this.cashPayment +
        this.chequePayment +
        this.loyalityPoints +
        this.giftVouchers -
        this.netAmount -
        this.card3PercentPay
      ).toFixed(2);
      this.remaining = 0;
      this.earnedLoyalityPoints = 0;
      this.earnedReferralPoints = 0;
      this.invoTotalProfit = 0;

      let totalPrdCost = 0;

      this.products.forEach((product) => {
        //****************previous calculation in which discount is deducted from gross amount that is bit unusual way even the
        // calculation is correct */

        // this.grossAmount += product.subTotal;
        // this.discount += +(
        //   (product.price * product.quantity * (product.discount || 0)) /
        //   100
        // ).toFixed(2);

        // // console.log("grossAmount", this.grossAmount, this.discount);
        // this.netAmount = +(this.grossAmount + this.tax - this.otherDiscount)
        //   // - this.discount // already deducted in sub total

        //   .toFixed(2);
        // *****************************************//

        this.grossAmount += +(
          product.subTotal +
          (product.price * product.quantity * (product.discount || 0)) / 100
        ).toFixed(2); // adding discount bcz prd subtotal is calculated deducting discount.
        // normally gross amount should be the value without that discount
        this.discount += +(
          (product.price * product.quantity * (product.discount || 0)) /
          100
        ).toFixed(2);

        // console.log("grossAmount", this.grossAmount, this.discount);

        if (this.serviceChargeMode === "Percentage") {
          this.netAmount = +(
            this.grossAmount +
            (this.grossAmount * this.sCharge) / 100 -
            this.discount -
            this.otherDiscount
          ).toFixed(2);
        } else {
          this.netAmount = +(
            this.grossAmount +
            this.sCharge -
            this.discount -
            this.otherDiscount
          ).toFixed(2);
        }

      // if (!this.$route.query.invoice && !this.$route.query.PO) {
      //   if (this.defaultPay && this.defaultPay === 'Cash' ) {
      //     this.cashPayment = this.netAmount
      //   }
      //   if (this.defaultPay && this.defaultPay === 'Card') {
      //     this.cardPayment = this.netAmount
      //   }
      // }

        const taxAmount = this.taxMode === 'Percentage' ? (this.netAmount * this.tax) / 100 : this.tax
        console.log("taxAmount",taxAmount,this.tax,this.cashPayment)
        this.balance = +(
          this.cardPayment +
          this.cashPayment +
          this.chequePayment +
          this.loyalityPoints +
          this.giftVouchers -
          this.netAmount -
          this.card3PercentPay -
          taxAmount
        ).toFixed(2);

        this.remaining = this.balance < 0 ? -1 * this.balance : 0;
        totalPrdCost += product.cost * product.quantity;
        this.invoTotalProfit = this.netAmount - totalPrdCost;

        this.earnedLoyalityPoints =
          ((this.netAmount - this.remaining) / 1000) *
          this.stores[0].loyalityPoints;
        this.earnedReferralPoints =
          ((this.netAmount - this.remaining) / 1000) *
          this.stores[0].referralPoints;
      });
    },
    updateProducts(index, row) {
      const foundPrd = this.products[index];
      foundPrd.subTotal = +(
        foundPrd.price * foundPrd.quantity -
        (foundPrd.price * foundPrd.quantity * (foundPrd.discount || 0)) / 100
      ).toFixed(2);
      const prdTotalCost = foundPrd.quantity * foundPrd.cost;
      foundPrd.profit = foundPrd.subTotal - prdTotalCost;
      console.log("foundPrd", foundPrd);
      // if (!this.$route.query.invoice && !this.$route.query.return) {
      //   foundPrd.availableQnty = foundPrd.availableQnty - row.quantity;
      // }
      this.updatePaymentDetails();
      if (
        (this.$route.query.invoice || this.$route.query.PO) &&
        this.$route.query.return === "true"
      ) {
        const returnAlready = this.returnedProducts.find(
          (product) =>
            product.barcode === row.barcode && product.serial === row.serial && product.cost === row.cost
        );
        const returnAlreadyOriginal = this.returnedProductsInitialClone.find(
          (product) =>
            product.barcode === row.barcode && product.serial === row.serial && product.cost === row.cost
        );
        const initialPrd = this.initialProducts.find(
          (product) =>
            product.barcode === row.barcode && product.serial === row.serial && product.cost === row.cost
        );
        if (returnAlready) {
          // console.log(returnAlready.quantity, initialPrd.quantity, row.quantity)
          // returnAlready.quantity - no of items returned
          returnAlready.quantity = +(
            initialPrd.quantity -
            row.quantity +
            (returnAlreadyOriginal ? returnAlreadyOriginal.quantity : 0)
          ).toFixed(2);
          returnAlready.subTotal = +(
            returnAlready.price * returnAlready.quantity -
            (returnAlready.price *
              returnAlready.quantity *
              (returnAlready.discount || 0)) /
              100
          ).toFixed(2);
          // foundPrd.availableQnty =
          //   initialPrd.availableQnty + returnAlready.quantity;
          foundPrd.noOfReturns = returnAlready.quantity;
          // console.log("already this.returnedProducts", this.returnedProducts);
        } else {
          // console.log(foundPrd.availableQnty, row.availableQnty);
          const quantity = +(initialPrd.quantity - row.quantity).toFixed(2);
          // foundPrd.availableQnty = foundPrd.availableQnty + quantity;
          foundPrd.noOfReturns = quantity;
          this.returnedProducts.push({
            quantity: quantity,
            name: row.name,
            barcode: row.barcode,
            discount: row.discount,
            subTotal: +(
              row.price * quantity -
              (row.price * quantity * (row.discount || 0)) / 100
            ).toFixed(2),
            price: row.price,
            category: row.category,
            subcategory: row.subcategory,
            cost: row.cost,
          });
          this.hasReturned = true;
          // console.log("this.returnedProducts", this.returnedProducts);
        }
      }
      // console.log("prds", this.products);
    },
    // Create callback function to receive barcode when the scanner is already done
    onBarcodeScanned(barcode) {
      if (this.$route.query.invoice || this.$route.query.PO) {
        return this.$notify.error({
          title: "Error",
          message: "Cannot add items when returning",
          type: "error",
        });
      }
      // console.log("barcode", barcode);
      this.productBarcode = barcode;
      this.fetchProducts(barcode);
      // if (!this.isInvoiceRendered) this.renderInvoice()
      this.isInvoiceRendered = true;
      // do something...
    },
    // Reset to the last barcode before hitting enter (whatever anything in the input box)
    resetBarcode() {
      let barcode = this.$barcodeScanner.getPreviousCode();
      // do something...
    },

    // invoice table
    handleEdit(index, row) {
      // console.log(index, row);
    },
    handleDelete(index, row) {
      // console.log("row", row);
      const oldProducts = this.products;
      this.products.splice(index, 1);
      if (
        (this.$route.query.invoice || this.$route.query.PO) &&
        this.$route.query.return === "true"
      ) {
        this.returnedProducts.push(row);
        this.hasReturned = true;
      }
      // console.log("this.returnedProducts", this.returnedProducts);
      this.updatePaymentDetails();
    },

    resetData() {
      this.isInvoiceRendered = true;
      this.isInvoiceCreated = false;
      this.search = "";
      this.customer = "";
      this.referralCustomer = "";
      this.referralCustomerMobile = "";
      this.referralCustomerName = "";
      this.productBarcode = "";
      this.invoiceNo = Math.floor(Math.random() * 10000000001).toString();
      this.date = "";
      this.invoiceDate = firebase.firestore.Timestamp.now();
      this.customerMobile = "";
      this.customerName = "";
      this.customerTotalLoyalityPoints = 0;
      this.maxLoyalityPoints = 0;
      this.grossAmount = 0;
      this.discount = 0;
      this.otherDiscount = 0;
      this.tax = 0;
      this.loyalityPoints = 0;
      this.giftVouchers = 0;
      this.earnedLoyalityPoints = 0;
      this.earnedReferralPoints = 0;
      this.netAmount = 0;
      this.cardPayment = 0;
      this.cashPayment = 0;
      this.chequePayment = 0;
      this.balance = 0;
      this.remaining = 0;
      this.dialogTableVisible = false;
      this.disabled = false;
      this.priceData = [];
      this.currentProduct = {};
      this.currentRow = null;
      this.initialProducts = [];
      this.returnedProducts = [];
      this.returnedProductsInitialClone = [];
      this.returnInvoiceData = "";
      this.hasReturned = false;
      this.products = [];
      this.card3Percent = false;
      this.card3PercentPay = 0;
      this.reportTotalRemaining = 0;
      this.reportTotalSales = 0;
      this.reportTotalProfit = 0;
      this.invoTotalProfit = 0;
      // this.profitReport = {}; this get reset before updating the report data
      this.formdata = {
        name: "",
        telephone: "",
      };
    },

    handleSelect(item) {
      // console.log(item);
      this.reports = [];
      if (!this.$route.query.invoice && !this.$route.query.PO) {
        this.products = []; // bcz already added item may not available for the newly selected store
      }
      this.categories = "";
      this.analyticsReport = {};
      this.profitReport = {};
      const date = new Date(this.invoiceDate.toDate().toISOString());
      const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 1);
      console.log("dates", firstDay, lastDay, date, this.invoiceDate);
      // console.log("storeeee", this.storeLocation);
      this.$store.state.secondaryDatabase
        .collection("reports")
        .where("date", ">=", firebase.firestore.Timestamp.fromDate(firstDay))
        .where("date", "<=", firebase.firestore.Timestamp.fromDate(lastDay))
        .where("storeLocation", "==", this.storeLocation)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const data = {
              id: doc.id,
              categories: doc.data().reportData,
              profitData: doc.data().profitData,
              totalPurcCost: doc.data().totalPurcCost,
              totalPurcDue: doc.data().totalPurcDue,
              totalSales: doc.data().totalSales,
              totalProfit: doc.data().totalProfit,
              totalRemaining: doc.data().totalRemaining,
            };
            this.reports.push(data);
            console.log("report", data);
            this.jsonDataforTest.reportInit = JSON.parse(
              JSON.stringify(this.reports[0])
            );
            this.analyticsReport = this.reports[0].categories;
            this.profitReport = this.reports[0].profitData;
            if (this.$route.name === "create-purchase-order") {
              this.reportTotalSales = this.reports[0].totalPurcCost;
              this.reportTotalRemaining = this.reports[0].totalPurcDue;
            }
            if (this.$route.name === "createinvoice") {
              this.reportTotalSales = this.reports[0].totalSales;
              this.reportTotalProfit = this.reports[0].totalProfit;
              this.reportTotalRemaining = this.reports[0].totalRemaining;
            }
            this.isReportExsists = true;

            console.log(
              "this.categories is",
              this.analyticsReport,
              this.profitReport
            );
          });
          if (!this.reports[0]) {
            this.isReportExsists = false;
            console.log("this.shops[0]t is", this.shops[0]);
            this.categories = this.shops[0].categories;
            Object.keys(this.categories).forEach((key, index) => {
              this.analyticsReport[key] = {};
              this.profitReport[key] = {};
              Object.keys(this.categories[key]).forEach((subcat, index) => {
                this.analyticsReport[key][subcat] = 0;
                this.profitReport[key][subcat] = 0;
              });
            });
            // console.log("this.analyticsReport is", this.analyticsReport);
          }
        })
        .catch((error) => console.log(error));
    },

    handleSupplierChange() {
      if (this.supplierMobile) {
        // console.log(customerType);
        const telephone = this.supplierMobile;

        const docRef = this.$store.state.secondaryDatabase.collection("suppliers");
        let firestoreQuery = docRef;
        if(this.$store.state.noDB === true) {
          firestoreQuery = firestoreQuery.where("shopOwner", "==", firebase.auth().currentUser.uid)
        }
        firestoreQuery
          .where("telephone", "==", +telephone)
          .get()
          .then((querySnapshot) => {
            let isCustomerFound;
            querySnapshot.forEach((doc) => {
              if (doc) isCustomerFound = true;
              const data = {
                id: doc.id,
                name: doc.data().name,
                // totalLoyalityPoints: doc.data().totalLoyalityPoints,
                totalPayment: doc.data().totalPayment,
                totalRemaining: doc.data().totalRemaining,
              };
              this.supplier = data;
              this.jsonDataforTest.supInit = JSON.parse(JSON.stringify(data));
              this.supplierName = data.name;
            });
            this.$notify({
              title: "Supplier Found",
              message: "Supplier found for telephone no " + telephone,
              type: "success",
            });
            if (!isCustomerFound) {
              return this.$notify.error({
                title: "Error",
                message: "Supplier not found for telephone no " + telephone,
                type: "error",
              });
            }
          })
          .catch((error) => alert(error.message));
      }
    },
    handleCustomerChange(customerType) {
      if (this.customerMobile || this.referralCustomerMobile) {
        // console.log(customerType);
        let telephone;
        if (customerType === "customer") {
          telephone = this.customerMobile;
          this.customer = "";
          this.customerName = "";
        }
        if (customerType === "referral") {
          telephone = this.referralCustomerMobile;
          this.referralCustomer = "";
          this.referralCustomerName = "";
        }
        const docRef = this.$store.state.secondaryDatabase.collection("customers");
        let firestoreQuery = docRef;
        if(this.$store.state.noDB === true) {
          firestoreQuery = firestoreQuery.where("shopOwner", "==", firebase.auth().currentUser.uid)
        }
        firestoreQuery
          .where("telephone", "==", +telephone)
          .get()
          .then((querySnapshot) => {
            let isCustomerFound;
            querySnapshot.forEach((doc) => {
              if (doc) isCustomerFound = true;
              const data = {
                id: doc.id,
                name: doc.data().name,
                totalLoyalityPoints: doc.data().totalLoyalityPoints,
                totalPayment: doc.data().totalPayment,
                totalRemaining: doc.data().totalRemaining,
              };
              if (customerType === "customer") {
                this.customer = data;
                this.jsonDataforTest.cusInit = JSON.parse(JSON.stringify(data));
                this.customerName = data.name;
                this.customerTotalLoyalityPoints = data.totalLoyalityPoints;
                this.maxLoyalityPoints = data.totalLoyalityPoints;
              }
              if (customerType === "referral") {
                this.referralCustomer = data;
                this.jsonDataforTest.refCusInit = JSON.parse(
                  JSON.stringify(data)
                );
                this.referralCustomerName = data.name;
                // console.log("this.referralCustomer", this.referralCustomer);
              }
            });
            this.$notify({
              title: "Customer Found",
              message: "Customer found for telephone no " + telephone,
              type: "success",
            });
            if (!isCustomerFound) {
              return this.$notify.error({
                title: "Error",
                message: "Customer not found for telephone no " + telephone,
                type: "error",
              });
            }
          })
          .catch((error) => alert(error.message));
      }
    },
     async handleProductChange(item) {
      console.log(this.productBarcode);
      this.productBarcode = item.barcode;
      console.log(this.productBarcode);
      if (this.$route.query.invoice || this.$route.query.PO) {
        return this.$notify.error({
          title: "Error",
          message: "Cannot add items when returning",
          type: "error",
        });
      }
      if (item) {
        await this.fetchProducts(item.barcode);
      }
    },
    async fetchProducts(barcode) {
      if (this.storeLocation === "" || this.storeLocation === undefined) {
        return alert("Please select store location");
      }
      const foundPrd = this.products.find(
        (product) => product.barcode === barcode
      );
      if (foundPrd) {
        this.currentProduct = JSON.parse(JSON.stringify(foundPrd));
        // foundPrd.quantity += 1;
        // this.updateProducts(1, foundPrd); // 1 is table index passed and its not used
        this.updatePriceData(foundPrd);
      }
      if (!foundPrd) {
        this.$store.state.secondaryDatabase
          .collection("products")
          .where("owner", "==", firebase.auth().currentUser.uid)
          .where("barcode", "==", barcode)
          .get()
          .then((querySnapshot) => {
            let isProductFound;
            querySnapshot.forEach((doc) => {
              if (doc) isProductFound = true;
              const data = {
                id: doc.id,
                name: doc.data().name,
                barcode: doc.data().barcode,
                category: doc.data().cat,
                altertQunty: doc.data().altertQunty,
                price: +doc.data().disprice.toFixed(2),
                priceList: doc.data().priceList,
                subcategory: doc.data().subcat,
                discount: +doc.data().dis.toFixed(2),
                // qntyList: doc.data().quantity,
                quantity: 1,
                //*********** not using as subtotal get updated correctly in handleCurrentChange(val) */
                subTotal: +(
                  doc.data().disprice * 1 -
                  (doc.data().disprice * (doc.data().dis || 0)) / 100
                ).toFixed(2), //*********** not using as subtotal get updated correctly in handleCurrentChange(val) */
              };
              this.currentProduct = data;
              this.updatePriceData(data);
            });
            if (!isProductFound) {
              return this.$notify.error({
                title: "Error",
                message: "Product not found for barcode " + barcode,
                type: "error",
              });
            }
          })
          .catch((error) => alert(error.message));
      }
    },
    updatePriceData(data) {
      this.priceData = [];
      if (data.priceList && data.priceList.length > 0) {
        const storePriceList = [];
        data.priceList.forEach((price) => {
          if (price.store === this.storeLocation) storePriceList.push(price);
        });
        if (
          storePriceList.length === 0 &&
          this.$route.name === "createinvoice"
        ) {
          return this.$notify.error({
            title: "Error",
            message: `${data.name} not available in the system's stock for the store`,
            type: "error",
          });
        }
        if (
          storePriceList.length === 0 &&
          this.$route.name === "create-purchase-order"
        ) {
          const priceForStore = {
            sellPr: 0,
            purcPr: 0,
            quantity: 0,
            serial: "",
            store: this.storeLocation,
          };
          storePriceList.push(priceForStore);
          this.currentProduct.priceList.push(priceForStore);
        }
        storePriceList.forEach((price) => {
          if (
            this.$route.name === "createinvoice" ||
            this.$route.name === "create-quotation"
          ) {
            this.priceData.push({
              name: data.name,
              price: +price.sellPr.toFixed(2),
              cost: +price.purcPr.toFixed(2),
              serial: price.serial,
              quantity: price.quantity
            });
          }
          if (this.$route.name === "create-purchase-order") {
            this.priceData.push({
              name: data.name,
              price: +price.purcPr.toFixed(2), // when adding PO price should be purcPr in prodUpdates methods
              cost: +price.purcPr.toFixed(2),
              serial: price.serial
            });
          }
        });
        if (this.priceData.length === 1) {
          if (storePriceList[0].quantity === 0 && this.$route.name === "createinvoice") {
            return this.$notify.error({
              title: "Error",
              message: `${data.name} not available in the system's stock for the store`,
              type: "error",
            });
          }
          this.handleCurrentChange(this.priceData[0]);
        } else this.dialogTableVisible = true;
      } else {
        // *************no need & not using as always having pricelist
        // this.products.push(data);
        // this.updatePaymentDetails();

        return this.$notify.error({
          title: "Error",
          message: `${data.name} not available in the system's stock for the store`,
          type: "error",
        });
        // console.log("this.categories is", this.products);
      }
    },
    handleCurrentChange(val) {
      if (val) {
        console.log("vallll", val);
        if (this.$route.name === "createinvoice" && val.quantity <= 0) {
          this.dialogTableVisible = false;
          return this.$notify.error({
            title: "Error",
            message: `${val.name} not available in the system's stock for the store`,
            type: "error",
          });
        }

        this.currentRow = val.price;
        //this.currentProduct.name = `${this.currentProduct.name} - ${val.serial}`
        this.currentProduct.price = val.price;
        this.currentProduct.cost = val.cost;
        this.currentProduct.serial = val.serial;
        this.currentProduct.subTotal = +(
          val.price * 1 -
          (val.price * (this.currentProduct.discount || 0)) / 100
        ).toFixed(2);
        this.currentProduct.profit = this.currentProduct.subTotal - val.cost;

        this.currentProduct.availableQnty = this.currentProduct.priceList.find(
          (item) =>
            item.store === this.storeLocation && item.serial === val.serial && item.purcPr === val.cost
        ).quantity;

        const foundPrdWithSamePrice = this.products.find(
          (product) =>
            product.barcode === this.productBarcode &&
            product.cost === val.cost &&
            product.serial === val.serial &&
            product.price === val.price // compare with cost bcz qantity count on purcPr
        );
        console.log("foundPrdWithSamePrice", foundPrdWithSamePrice, val);
        if (foundPrdWithSamePrice) {
          const index = this.products.findIndex(
            (product) =>
              product.barcode === this.productBarcode &&
              product.serial === val.serial &&
              product.cost === val.cost &&
              product.price === val.price
          );
          foundPrdWithSamePrice.quantity += 1;
          this.updateProducts(index, foundPrdWithSamePrice);
        } else {
          this.currentProduct.quantity = 1;
          if (this.$route.query.kot || this.$route.query.order || this.$route.query.job) {
            let itemList = [];
            if (this.$route.query.kot) itemList = this.kotItems
            if (this.$route.query.job) itemList = this.jobItems
            if (this.$route.query.order) itemList = this.orderItems
            console.log("kotItems",itemList,this.productBarcode)
            const isPrdInList = itemList.find( kotItem => kotItem.barcode === this.currentProduct.barcode)
            this.currentProduct.quantity = isPrdInList ? isPrdInList.quantity : 1
            this.currentProduct.subTotal = +(
              val.price * this.currentProduct.quantity -
              (val.price * (this.currentProduct.discount || 0)) / 100
            ).toFixed(2);
            this.currentProduct.profit = this.currentProduct.subTotal - (this.currentProduct.quantity * val.cost);
          }
          this.products.push(JSON.parse(JSON.stringify(this.currentProduct)));
          console.log("this.products", this.products);
          this.updatePaymentDetails();
        }

        this.currentProduct = {};
        this.productBarcode = "";
        console.log("this.products", this.products);
        this.dialogTableVisible = false;
      }
    },
  },
};
</script>


<style scoped>
/* @import url("invoice.css"); */
@import url("~@/assets/admin/css/admin-loader.css");

.text {
  font-size: 14px;
}

.item {
  margin-bottom: 0px;
  padding: 2px 0;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}

.box-card {
  /* width: 480px; */
}

.value {
  text-overflow: ellipsis;
  overflow: hidden;
}
.link {
  font-size: 12px;
  color: #818181;
  height: 15px;
}
.image {
    width: 100%;
    display: block;
    min-height: 227.3px;
    max-height: 227.3px
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/CreateInvoice.vue